/* ============================================================
   BLUE SALON — Product listing page (PLP) interactions
   Loaded only on the collection template (see layout/theme.liquid).
   Delegated listeners on #plpRoot so AJAX-refreshed / infinite-
   scroll-appended markup never needs re-binding.
   ============================================================ */
(function () {
  "use strict";

  var loadMoreObserver = null;
  var isLoadingMore = false;
  var lastRenderedHref = window.location.href;

  function storefrontUrl(path) {
    if (window.BS && typeof window.BS.storefrontUrl === "function") return window.BS.storefrontUrl(path);
    var shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (shopRoot || "/") + String(path || "").replace(/^\//, "");
  }

  /* ── Small helpers ────────────────────────────────────────── */
  function byId(id) {
    return document.getElementById(id);
  }

  // Escapes text/attribute values read back from the DOM (product title,
  // vendor, variant option names) before they're concatenated into a new
  // HTML string — those values went through Liquid's `escape` filter on
  // first render, but the browser decodes them back to plain text once
  // parsed into the DOM, so they need re-escaping here.
  function escapeHtml(str) {
    return String(str == null ? "" : str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function getVariants(card) {
    var script = card.querySelector("[data-variants-json]");
    if (!script) return [];
    try {
      return JSON.parse(script.textContent) || [];
    } catch (e) {
      return [];
    }
  }
window._usf_getVariants = getVariants;

  /* The product's full option structure, published by
     product-card.liquid as [data-options-json] — every option, including
     ones the tile has no row for.

     The USF search app renders its own product cards on the collection
     and search grids, and those carry neither that script nor a
     positional options array on their variants; only the colour/size
     pair. inferCardOptions rebuilds an equivalent structure for them, so
     Quick View there keeps behaving exactly as it did rather than
     rendering no pickers at all. */
  function getCardOptions(card, variants) {
    var script = card.querySelector("[data-options-json]");
    if (script) {
      try {
        var parsed = JSON.parse(script.textContent);
        // An empty array is product-card.liquid correctly reporting "nothing
        // pickable" (single-variant product) — `parsed.length` alone treated
        // that the same as a missing/broken script and fell through to
        // inferCardOptions, which re-derives options without the ">1 value"
        // filter and could report a phantom pending option. That reopened
        // Quick View for a single-variant product instead of adding it
        // straight to the bag. Only fall back when parsing truly failed.
        if (Array.isArray(parsed)) return parsed;
      } catch (e) {}
    }
    return inferCardOptions(card, variants);
  }

  function inferCardOptions(card, variants) {
    var productText = (window.BS_I18N && window.BS_I18N.product) || {};
    function valuesFrom(buttons) {
      return Array.prototype.map.call(buttons, function (btn) {
        return {
          name: btn.dataset.value,
          available: !btn.disabled,
          style: btn.getAttribute("style") || ""
        };
      });
    }

    // Every distinct value of a variant field (color/size), in first-seen
    // order — pulled from the card's FULL variants list rather than the
    // handful of swatch/size buttons USF actually renders on the tile
    // (USF's own color_template caps how many swatches show and, unlike our
    // own product-card.liquid, offers no "+N" for the rest). A colour with
    // real stock that simply didn't make USF's visible cap was otherwise
    // unreachable from Quick View — reading the variants array instead
    // surfaces every value the product actually has, USF-rendered or not.
    function valuesFromField(field) {
      var seen = {};
      var out = [];
      variants.forEach(function (v) {
        var name = v[field];
        if (name == null || seen[name]) return;
        seen[name] = true;
        out.push({
          name: name,
          available: variants.some(function (v2) { return v2[field] === name && v2.available; })
        });
      });
      return out;
    }

    // Excludes the "+N" button — it carries [data-swatch] so that clicking
    // it in the grid swaps the main image, but it's "+N" text rather than a
    // colour chip and has no value of its own.
    var swatches = card.querySelectorAll("[data-swatch]:not([data-swatch-more])");
    var sizes = card.querySelectorAll("[data-size]");
    // ">1" mirrors product-card.liquid's own options_json filter (only
    // options with more than one value are "worth picking" — a lone value,
    // Shopify's synthetic "Default Title" included, is already decided).
    // Checking merely whether the field is non-null instead let a
    // single-variant product's one-and-only size register as a "pending"
    // option below, which reopened Quick View instead of adding straight to
    // the bag — the tile itself already knew there was nothing to pick.
    var colorValues = valuesFromField("color");
    var sizeValues = valuesFromField("size");
    var hasColorField = colorValues.length > 1;
    var hasSizeField = sizeValues.length > 1;
    var options = [];
    var keys = [];

    if (hasColorField) {
      keys.push("color");
      options.push({ position: keys.length, name: productText.colour || "Colour", is_color: true, is_size: false, values: colorValues });
    } else if (swatches.length > 1) {
      keys.push("color");
      options.push({ position: keys.length, name: productText.colour || "Colour", is_color: true, is_size: false, values: valuesFrom(swatches) });
    }
    if (hasSizeField) {
      keys.push("size");
      options.push({ position: keys.length, name: productText.size || "Size", is_color: false, is_size: true, values: sizeValues });
    } else if (sizes.length > 1) {
      keys.push("size");
      options.push({ position: keys.length, name: productText.size || "Size", is_color: false, is_size: true, values: valuesFrom(sizes) });
    }

    // Stamp the matching positional array onto each variant so the one
    // matcher (findVariantByOptions) works for these cards too, instead
    // of needing a second colour/size-shaped code path.
    variants.forEach(function (v) {
      if (!Array.isArray(v.options)) {
        v.options = keys.map(function (k) { return v[k]; });
      }
    });

    return options;
  }
  /* Flat colour/size resolver. It keeps its own name because it is
     exported below as window._usf_findVariant and called with that exact
     signature by the USF search app (assets/usf.js, usf-custom.js) —
     not a signature we get to change. The rule itself now lives in
     assets/bs-variants.js, shared with the Quick View drawer, the
     wishlist drawer and the PDP, so the four cannot drift apart again.
     No local fallback on purpose: a second copy of the rule here is
     precisely the thing being removed. */
  function findVariant(variants, color, size) {
    return window.BSVariants.byField(variants, color, size);
  }
  window._usf_findVariant = findVariant;

  /* Positional sibling of findVariant, for the Quick View. Kept separate
     rather than folded into findVariant because that one is exported as
     window._usf_findVariant and called with (variants, color, size) by
     assets/usf.js and assets/usf-custom.js — its signature isn't ours to
     change. This matches on ALL of a product's options, so a shopper who
     picks a Width actually gets that width instead of whichever variant
     merely matched the colour and size.
       selected — { position: value }, partial selections allowed
       positions — the option positions the drawer is offering */
  function findVariantByOptions(variants, selected, positions) {
    return window.BSVariants.resolve(variants, selected, positions);
  }
  /* ── Wishlist (localStorage; mirrors header's decorative count) ── */
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem("bs_wishlist") || "[]");
    } catch (e) {
      return [];
    }
  }

  function setWishlist(ids) {
    try {
      localStorage.setItem("bs_wishlist", JSON.stringify(ids));
    } catch (e) {}
  }

  function updateWishCount(count) {
    document.querySelectorAll("#wishCount").forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  // "bs_wishlist_meta": id -> {handle}. bs_wishlist itself only ever holds
  // ids (no server-side id->product lookup exists), so the wishlist page
  // has to search the whole catalog to turn one back into a product. Saving
  // the handle here — already on hand, right on this button — the moment
  // something's wishlisted lets that page fetch it directly instead
  // (assets/wishlist.js's fetchProductByHandle), which is what makes it
  // load instantly instead of scanning /products.json.
  function saveWishlistHandle(id, handle) {
    if (!handle) return;
    try {
      var meta = JSON.parse(localStorage.getItem("bs_wishlist_meta") || "{}");
      meta[id] = { handle: handle };
      localStorage.setItem("bs_wishlist_meta", JSON.stringify(meta));
    } catch (e) {}
  }

  // Not every [data-wish-btn] carries data-product-handle — the USF search
  // app's own grid template (assets/usf.js, app-managed and NOT editable
  // here) renders its own wish button with no such attribute. But every
  // card template, ours or USF's, wraps the button in a product-link <a>
  // (.plp-card-media / [data-card-media]) — so the handle is recovered from
  // that link's href instead, which works regardless of which template
  // rendered the button.
  function extractProductHandle(btn) {
    if (btn.dataset.productHandle) return btn.dataset.productHandle;
    var media = btn.closest("[data-card-media]");
    var href = media && media.tagName === "A" ? media.getAttribute("href") : null;
    if (!href) href = window.location.pathname; // PDP: the button lives on the product's own page
    var match = href && href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function toggleWishlist(btn) {
    var id = btn.dataset.productId;
    if (!id) return;
    var ids = getWishlist();
    var idx = ids.indexOf(id);
    var active;
    if (idx === -1) {
      ids.push(id);
      active = true;
    } else {
      ids.splice(idx, 1);
      active = false;
    }
    setWishlist(ids);
    if (active) saveWishlistHandle(id, extractProductHandle(btn));
    btn.classList.toggle("is-active", active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");
    updateWishCount(ids.length);
    showToast(
      active ? "Added to your wishlist" : "Removed from your wishlist",
      false,
      active ? WISH_ICON_ADDED : WISH_ICON_REMOVED
    );
  }

  function hydrateWishlist() {
    var ids = getWishlist();
    document.querySelectorAll("[data-wish-btn]").forEach(function (btn) {
      var active = ids.indexOf(btn.dataset.productId) !== -1;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
    updateWishCount(ids.length);
  }

  /* ── Card title: drop a leading brand name — with or without a
     " - " separator ("Majouri - Crazy..." / "Tom Ford Ombré...") —
     so it isn't duplicated with the .plp-card-brand line above it.
     USF's grid isn't rendered by our Liquid snippet, so this runs on
     load and again on every USF re-render (see watchUsfGrid below). */
  function stripBrandPrefixes(scope) {
    (scope || document).querySelectorAll(".plp-card-name").forEach(function (nameEl) {
      var card = nameEl.closest(".plp-card");
      var brandEl = card && card.querySelector(".plp-card-brand");
      var brand = brandEl && brandEl.textContent.trim();
      if (!brand) return;
      var text = nameEl.textContent;
      if (text.slice(0, brand.length).toLowerCase() !== brand.toLowerCase()) return;
      var rest = text.slice(brand.length).replace(/^\s*-?\s*/, "");
      nameEl.textContent = rest;
    });
  }

  /* ── Colour swatches: backfill a thumbnail where the template couldn't ──
     Both card templates (snippets/product-card.liquid and
     templates/product.usf-extra.liquid) now print each colour's variant
     photo themselves, so swatches arrive as .plp-swatch-img already and
     this pass leaves them alone. It still covers the leftovers — a colour
     with no linked variant image at all, or markup from a grid template
     we don't control — by falling back to the card's main image, since
     these products have no Shopify swatch.color configured and a flat
     chip would render blank. */
  /* ── Main + hover card image: match the default-active swatch, not
     whatever product.featured_image/hover_media happen to be ── Both card
     templates render the very first colour as .is-active by default, but
     the initial <img data-card-img-main> src comes from
     product.featured_image and .plp-card-hoverimg from the first media
     image that differs from it — both independent, arbitrary fields,
     only in sync with the active colour by coincidence. Same fix as
     selectSwatch() applies on click, just run once up front for the
     page's initial state. Runs before renderSwatchThumbnails so its
     main-image fallback (for swatches with no image of their own) is
     already correct. */
  function syncMainImageToActiveSwatch(scope) {
    (scope || document).querySelectorAll(".plp-card").forEach(function (card) {
      var activeSwatch = card.querySelector("[data-swatch].is-active");
      var img = card.querySelector("[data-card-img-main]");
      if (!activeSwatch || !img || !activeSwatch.dataset.image) return;
      if (img.src !== activeSwatch.dataset.image) {
        img.src = activeSwatch.dataset.image;
        img.removeAttribute("srcset");
      }

      var hoverImg = card.querySelector(".plp-card-hoverimg");
      if (!hoverImg) return;
      var hoverSrc = activeSwatch.dataset.hoverImage || activeSwatch.dataset.image;
      if (hoverImg.src !== hoverSrc) {
        hoverImg.src = hoverSrc;
        hoverImg.removeAttribute("srcset");
      }
    });
  }

  function renderSwatchThumbnails(scope) {
    (scope || document).querySelectorAll(".plp-card").forEach(function (card) {
      var mainImg = card.querySelector("[data-card-img-main]");
      var fallbackSrc = mainImg && mainImg.src;
      card.querySelectorAll(".plp-swatch").forEach(function (btn) {
        // Prefer the small (160px) thumbnail for the tiny swatch box; fall back
        // to the full 800px variant image (used for the click-to-swap main
        // image) and finally the card's already-loaded main image. Loading
        // 800px images into 30px boxes left them sitting on the grey
        // placeholder while they downloaded — most visible on mobile with
        // several swatches per card.
        var url = btn.dataset.thumb || btn.dataset.image || fallbackSrc;
        if (!url) return;
        // Bail out when this button already shows a photo — either baked in by
        // the templates (the normal case now: both product-card.liquid and
        // templates/product.usf-extra.liquid print the variant photo
        // themselves, so nothing flips from a flat chip on load) or applied by
        // an earlier pass. Not just a micro-optimisation: watchUsfGrid observes
        // class/style attributes to survive USF re-rendering over our work, so
        // a pass that rewrote already-correct buttons would trip its own
        // observer and re-schedule itself forever.
        if (
          btn.classList.contains("plp-swatch-img") &&
          btn.style.backgroundImage &&
          !btn.style.backgroundColor
        ) {
          return;
        }
        btn.classList.add("plp-swatch-img");
        btn.style.backgroundImage = "url('" + url + "')";
        btn.style.backgroundColor = "";
      });
    });
  }

  /* ── Colour swatches: sold-out state, derived from the actual variants ──
     USF supplies each card's full variants list (data-variants-json), but
     its own swatch markup doesn't reliably mark a colour with zero stock
     as sold out — the flat cross-through strike (.plp-swatch.is-soldout,
     in listing.css) simply never appears, even though the CSS for it has
     existed all along. Derive it from the same variants data everything
     else on the card already reads instead of trusting whatever class
     USF's template happened to apply. Runs on load and again on every USF
     re-render (see watchUsfGrid below). */
  // Rewrites an already-rendered swatch button to represent a different
  // variant's colour — used when the only colour with real stock is one
  // USF/product-card.liquid never gave a swatch to (hidden behind "+N",
  // beyond the tile's visible cap), so there's no existing button for it
  // to just switch to. Re-applies the same image-thumbnail treatment
  // renderSwatchThumbnails already ran for every OTHER swatch, since that
  // pass is long done by the time this repurposes one.
  function repurposeSwatchForVariant(card, btn, variant) {
    var mainImg = card.querySelector("[data-card-img-main]");
    var fallbackSrc = mainImg && mainImg.src;

    btn.dataset.value = variant.color;
    if (variant.id) btn.dataset.variantId = variant.id;
    if (variant.image) {
      btn.dataset.image = variant.image;
      btn.dataset.thumb = variant.image;
    } else {
      delete btn.dataset.image;
      delete btn.dataset.thumb;
    }
    delete btn.dataset.hoverImage;

    btn.classList.remove("is-soldout");
    btn.disabled = false;
    btn.setAttribute("aria-disabled", "false");
    if (btn.hasAttribute("title")) btn.setAttribute("title", variant.color);
    if (btn.hasAttribute("aria-label")) btn.setAttribute("aria-label", variant.color);

    var url = btn.dataset.thumb || btn.dataset.image || fallbackSrc;
    if (url) {
      btn.classList.add("plp-swatch-img");
      btn.style.backgroundImage = "url('" + url + "')";
      btn.style.backgroundColor = "";
    } else {
      btn.classList.remove("plp-swatch-img");
      btn.style.backgroundImage = "";
      btn.style.backgroundColor = String(variant.color).replace(/\s+/g, "");
    }
  }

  function markSwatchAvailability(scope) {
    (scope || document).querySelectorAll(".plp-card").forEach(function (card) {
      var variants = getVariants(card);
      if (!variants.length) return;
      var swatches = card.querySelectorAll("[data-swatch]:not([data-swatch-more])");
      swatches.forEach(function (btn) {
        var value = btn.dataset.value;
        var available = variants.some(function (v) { return v.color === value && v.available; });
        btn.classList.toggle("is-soldout", !available);
        btn.disabled = !available;
        btn.setAttribute("aria-disabled", available ? "false" : "true");
        if (btn.hasAttribute("title")) {
          btn.setAttribute("title", value + (available ? "" : " (Sold out)"));
        }
        if (btn.hasAttribute("aria-label")) {
          btn.setAttribute("aria-label", value + (available ? "" : " (Sold out)"));
        }
      });

      // The default active swatch is just "whichever colour renders
      // first" (forloop.first in product-card.liquid; USF's own template
      // follows the same convention) — easy for it to be sold out while a
      // colour sitting right next to it on the tile has stock. Re-point
      // the card at the first available one instead, same as
      // openQuickView already does for the drawer. selectSwatch() also
      // swaps the main image, hover image, variant link and price to
      // match, so the whole tile — not just the swatch row — reflects a
      // colour a shopper can actually buy.
      var activeSwatch = card.querySelector("[data-swatch].is-active");
      if (activeSwatch && activeSwatch.classList.contains("is-soldout")) {
        var availableSwatch = Array.prototype.filter.call(swatches, function (b) {
          return !b.classList.contains("is-soldout");
        })[0];

        // None of the swatches actually rendered on the tile are in stock —
        // the one colour that IS available may be sitting entirely behind
        // "+N" with no swatch of its own. Repurpose the active swatch into
        // that colour rather than leave the tile stuck on a guaranteed
        // Sold Out default with no way to reach the real stock at all.
        if (!availableSwatch) {
          var bestAvailable = window.BSVariants.bestAvailable(variants);
          if (bestAvailable && bestAvailable.color) {
            repurposeSwatchForVariant(card, activeSwatch, bestAvailable);
            availableSwatch = activeSwatch;
          }
        }

        if (availableSwatch) selectSwatch(availableSwatch);
      }
    });
  }

  /* ── Quick-add button state: same markup/text for all three states
     (Add to Bag / Quick View / Sold Out — see snippets/product-card.liquid
     and USF's matching template in assets/usf.js), with no class to hang
     an icon off. Tag one on here instead of touching that markup twice
     (once safely, once in the app-managed, do-not-edit usf.js). Runs on
     load and again on every USF re-render (see watchUsfGrid below). */
  function tagQuickaddState(scope) {
    var quickViewLabel = String((window.BS_I18N || {}).quick_view || "").trim().toLowerCase();
    (scope || document).querySelectorAll(".plp-quickadd-btn").forEach(function (btn) {
      var text = btn.textContent.trim().toLowerCase();
      var state = "addtocart";
      if (btn.disabled || text.indexOf("sold out") !== -1) {
        state = "soldout";
      } else if (text.indexOf("quick view") !== -1 || btn.querySelector(".plp-quickadd-eye") ||
          (quickViewLabel && text === quickViewLabel)) {
        // iconizeQuickviewButtons swaps the English label for the translated
        // one, so a later pass must still recognise the button by that.
        state = "quickview";
      }
      btn.classList.toggle("is-addtocart", state === "addtocart");
      btn.classList.toggle("is-quickview", state === "quickview");
      btn.classList.toggle("is-soldout", state === "soldout");
    });
  }

  // USF's own card template still renders its stock "Add to Cart" wording,
  // plain text with no icon (loc.addToCart, set via the app's own in-app
  // text customization) — relabel it to match "Add to bag" everywhere else
  // on the site (PDP, quick view drawer, men's PLP quick-add) and prepend
  // the same plus icon those use (.plp-quickadd-plus, see product-card.liquid
  // / wishlist.js). Same do-not-edit-usf.js reasoning as tagQuickaddState
  // above; runs right after it so the is-addtocart class (keyed off the
  // original text) is already settled. Guarded on the icon's own presence,
  // not just the text, so a repeat pass over an already-patched button is a
  // no-op instead of re-inserting the SVG.
  function relabelQuickaddButtons(scope) {
    (scope || document).querySelectorAll(".plp-quickadd-btn.is-addtocart").forEach(function (btn) {
      if (btn.querySelector(".plp-quickadd-plus")) return;
      if (btn.textContent.trim().toLowerCase() === "add to cart") {
        btn.innerHTML =
          '<svg class="plp-quickadd-plus" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>Add to bag';
      }
    });
  }

  // Same USF plain-text gap for "Quick View" — no icon anywhere else on the
  // site pairs with that label (native cards leave it text-only, see
  // product-card.liquid/wishlist.js) to reuse, so this borrows the eye glyph
  // already defined for mobile's icon-only .is-quickview::before (listing.css)
  // instead of inventing an unrelated one. Same guard pattern as
  // relabelQuickaddButtons above.
  function iconizeQuickviewButtons(scope) {
    (scope || document).querySelectorAll(".plp-quickadd-btn.is-quickview").forEach(function (btn) {
      if (btn.querySelector(".plp-quickadd-eye")) return;
      // The USF card template hardcodes the English label; swap in the
      // storefront's own translation (snippets/storefront-i18n.liquid).
      if (btn.textContent.trim().toLowerCase() === "quick view") {
        btn.innerHTML =
          '<svg class="plp-quickadd-eye" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/></svg>' +
          escapeHtml((window.BS_I18N || {}).quick_view || "Quick View");
      }
    });
  }

  /* ── Card layout: quick-add icon beside the brand name (mobile only) ──
     .plp-quickadd lives in .plp-card-media (over the image, absolutely
     positioned there for desktop's hover-reveal bar) and .plp-card-price
     lives inside .plp-card-row (beside the brand) in both card templates
     — there's no CSS-only way to show the quick-add icon next to the
     brand instead, since they're in different containers. Re-parent both
     on mobile: price moves out of the brand row to sit after the name,
     and the quick-add button moves into that now-freed spot in the row —
     then reverse it above the breakpoint so desktop's absolutely-
     positioned hover bar keeps working. Idempotent (checks parentElement
     first) so re-running on every USF re-render / resize doesn't thrash. */
  var CARD_MOBILE_QUERY = "(max-width: 760px)";

  function layoutCardInfo(scope) {
    var isMobile = window.matchMedia(CARD_MOBILE_QUERY).matches;
    (scope || document).querySelectorAll(".plp-card").forEach(function (card) {
      var row = card.querySelector(".plp-card-row");
      var media = card.querySelector(".plp-card-media");
      var name = card.querySelector(".plp-card-name");
      var price = card.querySelector(".plp-card-price");
      var quickadd = card.querySelector(".plp-quickadd");
      if (!row || !name || !price) return;

      if (isMobile) {
        if (price.parentElement === row) {
          name.insertAdjacentElement("afterend", price);
        }
        if (quickadd && quickadd.parentElement !== row) {
          row.appendChild(quickadd);
        }
      } else {
        if (price.parentElement !== row) {
          row.appendChild(price);
        }
        if (quickadd && media && quickadd.parentElement !== media) {
          media.appendChild(quickadd);
        }
      }
    });
  }

  /* ── Brand/name height: match within each visual row only ──────
     Long brand or product names wrap to 2 lines while short ones stay on
     1, pushing whatever comes after (name/price, or price/swatches) down
     for the 2-line card only. A fixed 2-line reservation (CSS) fixed the
     misalignment but left a wasted gap under every 1-line card — most
     brand names especially are short, so that's the common case. Group
     cards by their current row (rounded viewport top — reflows with
     column count/viewport width, so this must be re-run on resize) and
     only stretch a row's elements to match its OWN tallest one, so a row
     where everything's 1 line stays compact. Resets to natural height
     first so a stale forced min-height from a previous pass/column count
     doesn't get measured as if it were real content. */
  var EQUALIZE_SELECTORS = [".plp-card-brand", ".plp-card-name"];

  function equalizeCardHeights() {
    var cards = Array.prototype.slice.call(document.querySelectorAll(".plp-card"));
    if (!cards.length) return;

    // Reset every selector on every card before measuring any of them —
    // a stale forced min-height from a previous pass/column count would
    // otherwise get measured as if it were real content.
    EQUALIZE_SELECTORS.forEach(function (sel) {
      cards.forEach(function (card) {
        var el = card.querySelector(sel);
        if (el) el.style.minHeight = "";
      });
    });

    var rows = {};
    cards.forEach(function (card) {
      var top = Math.round(card.getBoundingClientRect().top);
      (rows[top] = rows[top] || []).push(card);
    });

    Object.keys(rows).forEach(function (key) {
      var group = rows[key];
      if (group.length < 2) return;
      EQUALIZE_SELECTORS.forEach(function (sel) {
        var maxHeight = 0;
        group.forEach(function (card) {
          var el = card.querySelector(sel);
          if (el) maxHeight = Math.max(maxHeight, el.getBoundingClientRect().height);
        });
        group.forEach(function (card) {
          var el = card.querySelector(sel);
          if (el) el.style.minHeight = maxHeight + "px";
        });
      });
    });
  }

  function watchCardLayoutResize() {
    var scheduled = false;
    window.addEventListener("resize", function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        layoutCardInfo();
        equalizeCardHeights();
        syncQuickfiltersForViewport();
        // Crossing the mobile/desktop breakpoint swaps chip ownership between
        // our mobile chips and USF's desktop breadcrumb — reconcile here.
        renderMobileFilterChips();
        // The grid drops to 3 columns under 1200px and 2 under 1024px, so a
        // resize past either one changes how many products fill whole rows.
        // No-op unless the count really moved (snippets/plp-page-size).
        if (window.bsPlpFillRows) window.bsPlpFillRows.update();
      });
    });
  }

  /* Mobile filter-icon badge (see .plp-filter-badge CSS) on the
     USF-integrated page — USF filters entirely client-side (its own Vue
     store, no native Shopify filter.* URL params), so the server-rendered
     initial count from collection.filters can't reflect it; read USF's
     own applied-filter list instead. usf.queryRewriter.facetFilters is the
     same state USF's own "X removed" breadcrumb (.usf-refineby, see
     assets/usf-custom.js) renders from — keyed by facet id, each value is
     [facetKey, [selectedValue, ...]]. Sum the selected-value arrays to
     match the desktop badge's active_filter_count (collection.liquid). */
  function updateFilterBadgeFromUsf() {
    var badge = byId("plpFilterBadge");
    var clearBtn = byId("plpClearFilters");
    if ((!badge && !clearBtn) || !window.usf || !usf.queryRewriter) return;
    var filters = usf.queryRewriter.facetFilters;
    // Item Type has its own active state on the head-band pills — don't
    // double-count it into "N filters applied" for the sidebar/drawer.
    var itemTypeFacet = usfItemTypeFacet();
    var itemTypeFacetId = itemTypeFacet ? String(itemTypeFacet.id) : null;
    var count = 0;
    for (var facetId in filters) {
      if (Object.prototype.hasOwnProperty.call(filters, facetId) && facetId !== itemTypeFacetId) {
        count += filters[facetId][1].length;
      }
    }
    if (badge) {
      badge.textContent = count > 0 ? String(count) : "";
      badge.hidden = count === 0;
    }
    if (clearBtn) clearBtn.hidden = count === 0;
  }

  // "Clear all" (sidebar/drawer bar) — reassigns USF's facetFilters to just
  // whatever Item Type entry it already had (that facet has its own reset
  // via the head-band "All" pill, see applyItemTypeFacet(null); this button
  // only clears the OTHER facets, matching what updateFilterBadgeFromUsf
  // above already counts/excludes). Same reassign-triggers-refilter
  // mechanism as removeUsfFacetValue/applyItemTypeFacet.
  function clearAllUsfFilters() {
    if (!window.usf || !usf.queryRewriter) return;
    var ff = usf.queryRewriter.facetFilters || {};
    var itemTypeFacet = usfItemTypeFacet();
    var itemTypeFacetId = itemTypeFacet ? String(itemTypeFacet.id) : null;
    var next = {};
    if (itemTypeFacetId && ff[itemTypeFacetId]) next[itemTypeFacetId] = ff[itemTypeFacetId];
    usf.queryRewriter.facetFilters = next;
  }

  // Facet display name from USF's facet key: "option:Color" → "Color",
  // "metafield:custom.material" → "Material", "vendor" → "Brand" (storefront
  // copy calls Shopify's vendor field "Brand", not "Vendor").
  function usfFacetLabel(facetKey) {
    var name = String(facetKey || "").split(":").pop().split(".").pop();
    if (name.toLowerCase() === "vendor") return "Brand";
    return name ? name.charAt(0).toUpperCase() + name.slice(1) : "";
  }

  // Mobile active-filter chips. USF only emits its .usf-refineby breadcrumb on
  // desktop (relocated by relocateActiveFilters); on mobile it emits none, so
  // build equivalent removable chips from the same usf.queryRewriter
  // .facetFilters state into the same #plpActiveFilters slot — matching the
  // desktop "Facet: Value ×" chips so mobile shows selected filters too.
  // A chip's facet name: the search app's own facet title ("Gender", not the
  // raw "tags" field usfFacetLabel falls back to), in the storefront's
  // language when snippets/storefront-i18n.liquid has a translation for it.
  // USF empties its facet list when a filter combination has no results, so
  // titles are remembered (for the session) whenever the list is populated.
  var USF_FACET_TITLES_KEY = "bs_usf_facet_titles";
  var usfFacetTitles = null;

  function rememberUsfFacetTitles() {
    if (!usfFacetTitles) {
      try { usfFacetTitles = JSON.parse(sessionStorage.getItem(USF_FACET_TITLES_KEY) || "{}") || {}; } catch (e) { usfFacetTitles = {}; }
    }
    var facets = [];
    try { facets = usf.store.useFacetsStore().facets || []; } catch (e) {}
    if (!facets.length) return;
    facets.forEach(function (f) {
      if (f && f.id != null && f.title) usfFacetTitles[String(f.id)] = String(f.title).trim();
    });
    try { sessionStorage.setItem(USF_FACET_TITLES_KEY, JSON.stringify(usfFacetTitles)); } catch (e) {}
  }

  function usfChipLabel(facetId, facetKey) {
    rememberUsfFacetTitles();
    var title = (usfFacetTitles && usfFacetTitles[String(facetId)]) || usfFacetLabel(facetKey);
    var map = (window.BS_I18N || {}).facet_titles || {};
    return map[title.toLowerCase()] || title;
  }

  function renderMobileFilterChips() {
    // Runs on every USF render, so facet titles are on record before a
    // filter combination with no results empties USF's facet list.
    if (window.usf) rememberUsfFacetTitles();
    var slot = byId("plpActiveFilters");
    if (!slot) return;
    if (!window.matchMedia(CARD_MOBILE_QUERY).matches) {
      // Desktop uses USF's own relocated breadcrumb — drop any chips we built,
      // the mobile-only "Clear all" chip included: left behind, it sat above
      // USF's chips after a phone-width page widened (tablet rotation).
      var mine = slot.querySelectorAll("[data-usf-chip], [data-usf-clear-all-chip]");
      Array.prototype.forEach.call(mine, function (c) { c.remove(); });
      return;
    }
    if (!window.usf || !usf.queryRewriter) return;
    var ff = usf.queryRewriter.facetFilters || {};
    // Item Type already has its own active state on the head-band pills —
    // skip it here too, same reasoning as hideItemTypeChip (desktop).
    var itemTypeFacet = usfItemTypeFacet();
    var itemTypeFacetId = itemTypeFacet ? String(itemTypeFacet.id) : null;
    // Likewise Gender where the Men / Women pills show it.
    var genderPill = usfGenderPillFacet();
    var genderFacetId = genderPill ? String(genderPill.facet.id) : null;
    var html = "";
    Object.keys(ff).forEach(function (facetId) {
      if (facetId === itemTypeFacetId || facetId === genderFacetId) return;
      var entry = ff[facetId];
      if (!entry || !Array.isArray(entry[1])) return;
      var label = usfChipLabel(facetId, entry[0]);
      var removeLabel = (window.BS_I18N || {}).remove_filter || "Remove filter";
      entry[1].forEach(function (value) {
        // dir="auto" on the value: a Latin brand name keeps its own order
        // inside an Arabic chip, and a long one is cut short at its end
        // ("Santa Barbara…") by the ellipsis in listing.css rather than at
        // its start, without pushing the × out of view.
        html +=
          '<button type="button" class="plp-chip" data-usf-chip ' +
            'data-facet-id="' + escapeHtml(facetId) + '" ' +
            'data-facet-value="' + escapeHtml(value) + '" ' +
            'aria-label="' + escapeHtml(removeLabel + " " + label + ": " + value) + '" ' +
            'title="' + escapeHtml(value) + '">' +
            '<span class="plp-chip-label">' + escapeHtml(label) + ': <b dir="auto">' + escapeHtml(value) + "</b></span>" +
            '<span class="plp-chip-x" aria-hidden="true">&times;</span>' +
          "</button>";
      });
    });
    // Mobile has no equivalent of the desktop sidebar's #plpClearFilters
    // (USF's own full-screen filter modal intercepts #plpFilterCollapse/
    // #plpFilterToggle on mobile — see the delegated click handler below —
    // so that drawer, and its Clear all button, never opens there). Append
    // one more chip here instead, the only filter-state UI mobile actually
    // shows.
    if (html) {
      html += '<button type="button" class="plp-chip plp-chip--clear-all" data-usf-clear-all-chip>' + escapeHtml((window.BS_I18N || {}).clear_all || "Clear all") + '</button>';
    }
    slot.innerHTML = html;
  }

  // Removes one selected facet value by reassigning USF's facetFilters — its
  // setter rewrites the uff_ URL params and triggers a re-filter. Mirrors the
  // desktop breadcrumb's removeFacetFilter(facetId, value).
  function removeUsfFacetValue(facetId, value) {
    if (!window.usf || !usf.queryRewriter) return;
    var ff = usf.queryRewriter.facetFilters || {};
    var entry = ff[facetId];
    if (!entry) return;
    var next = {};
    Object.keys(ff).forEach(function (k) { next[k] = ff[k]; });
    var remaining = entry[1].filter(function (v) { return v !== value; });
    if (remaining.length) next[facetId] = [entry[0], remaining];
    else delete next[facetId];
    usf.queryRewriter.facetFilters = next;
  }

  // USF's facet *definitions* (id, title, the underlying key it filters on,
  // and every possible value with its live count) live in a Pinia store, not
  // in queryRewriter — usf.store.useFacetsStore().facets, an array of
  // { id, title, facetName, multiple, labels: [{ label, value: count }] }.
  // Confirmed live: the "Item Type" facet is { id: <n>, facetName: "tags",
  // multiple: 0 } — single-select, so setting (not appending to)
  // facetFilters[id] is correct.
  function usfItemTypeFacet() {
    if (!window.usf || !usf.store || !usf.store.useFacetsStore) return null;
    // On a page without a USF results app (the Special Prices page loads listing.js
    // for its cards) the store exists but no Pinia is active, and asking for
    // it throws - which took down the rest of the PLP boot with it.
    var facets;
    try {
      facets = usf.store.useFacetsStore().facets || [];
    } catch (e) {
      return null;
    }
    for (var i = 0; i < facets.length; i++) {
      if (String(facets[i].title || "").trim().toLowerCase() === "item type") return facets[i];
    }
    return null;
  }

  // Gender facet ("Mens" / "Womens" tags) for collections that start their
  // category row with Men's / Women's Fashion pills. Only on collections
  // listed in the section's "Collections with Men / Women pills" setting
  // (#plpRoot[data-gender-pills]), and only while the facet offers the
  // values that have a pill label (BS_I18N.gender_pills).
  function usfGenderPillFacet() {
    var root = byId("plpRoot");
    if (!root || !root.hasAttribute("data-gender-pills")) return null;
    if (!window.usf || !usf.store || !usf.store.useFacetsStore) return null;
    var facets;
    try {
      facets = usf.store.useFacetsStore().facets || [];
    } catch (e) {
      return null;
    }
    var names = (window.BS_I18N || {}).gender_pills || {};
    for (var i = 0; i < facets.length; i++) {
      if (String(facets[i].title || "").trim().toLowerCase() !== "gender") continue;
      var labels = (facets[i].labels || []).filter(function (l) {
        return names[String(l.label || "").trim().toLowerCase()];
      });
      // Pill order follows BS_I18N.gender_pills (Men first), not facet counts.
      var order = Object.keys(names);
      labels.sort(function (a, b) {
        return order.indexOf(String(a.label).trim().toLowerCase()) - order.indexOf(String(b.label).trim().toLowerCase());
      });
      return labels.length ? { facet: facets[i], labels: labels } : null;
    }
    return null;
  }

  // Picking (or clearing) a gender pill also clears the item type: the
  // item types on offer are that gender's own.
  function applyGenderPill(value) {
    var g = usfGenderPillFacet();
    if (!g || !usf.queryRewriter) return;
    var itemType = usfItemTypeFacet();
    var ff = usf.queryRewriter.facetFilters || {};
    var next = {};
    Object.keys(ff).forEach(function (k) { next[k] = ff[k]; });
    if (itemType) delete next[itemType.id];
    if (value == null) delete next[g.facet.id];
    else next[g.facet.id] = [g.facet.facetName, [value]];
    usf.queryRewriter.facetFilters = next;
  }

  // Single-select set/clear for the Item Type facet — mirrors
  // removeUsfFacetValue's direct-reassignment approach (same setter, same
  // re-filter trigger) but replaces the facet's whole value list with just
  // one value (or clears it entirely for value === null), since Item Type
  // only ever allows one active value at a time.
  function applyItemTypeFacet(value) {
    var facet = usfItemTypeFacet();
    if (!facet || !usf.queryRewriter) return;
    var ff = usf.queryRewriter.facetFilters || {};
    var next = {};
    Object.keys(ff).forEach(function (k) { next[k] = ff[k]; });
    if (value == null) delete next[facet.id];
    else next[facet.id] = [facet.facetName, [value]];
    usf.queryRewriter.facetFilters = next;
  }

  /* "On Sale" pill: narrows the collection to its Special Prices items (tag
     PROMOCEGID) in place, like the Item Type pills. USF has no sale facet
     and its facetFilters setter only takes numeric facet ids, so the state
     lives in the page URL (?sale=1 - shareable, and Back undoes it) and the
     tag filter is added to each USF search request while it is on - the
     same request-level filter the Special Prices category pages use. USF re-runs
     its search on any URL change (usf-boot.js wraps history.pushState), so
     toggling the param is all a tap needs to do. A one-off count of the
     collection's sale items decides whether the pill shows at all. */
  // Tag and label come from Theme settings > Sale filter pill, written by
  // snippets/usf.liquid as window.bsSalePill; no bsSalePill = pill off.
  var SALE_PARAM = "sale";
  var salePill = window.bsSalePill || null;
  var SALE_FILTER = ["tags", [salePill ? salePill.tag : ""]];
  var saleCount = null;
  var saleProbeSent = false;

  function saleFilterOn() {
    return new URLSearchParams(window.location.search).get(SALE_PARAM) === "1";
  }

  function withSaleFilter(facetFilters) {
    var asString = typeof facetFilters === "string";
    var ff = asString ? JSON.parse(facetFilters || "{}") : (facetFilters || {});
    var next = {};
    Object.keys(ff).forEach(function (k) { next[k] = ff[k]; });
    next._usf_sale = SALE_FILTER;
    return asString || facetFilters == null ? JSON.stringify(next) : next;
  }

  /* "New In" pill: the same in-place narrowing as On Sale, to the collection's
     new-arrivals tag, on the collections Theme settings > New In filter pill
     lists (snippets/usf.liquid sets window.bsNewInPill only there and adds
     the tag to each search while ?new=1 is on). */
  var NEW_PARAM = "new";
  var newInPill = window.bsNewInPill || null;
  var newInCount = null;
  var newInProbeSent = false;

  function newInFilterOn() {
    return !!newInPill && new URLSearchParams(window.location.search).get(NEW_PARAM) === "1";
  }

  // How many of the page's products one tag filter leaves, in the same scope
  // as the page's own search - this collection (its numeric id, set by
  // snippets/usf.liquid) or, on the search page, the term.
  function probeCount(facetFilters, done) {
    var collectionId = window._usfCollectionId || "";
    var query = {
      apiKey: usf.settings.siteId,
      q: collectionId ? "" : (usf.queryRewriter ? usf.queryRewriter.term : ""),
      locale: (usf.platform && usf.platform.locale) || "en",
      country: (usf.platform && usf.platform.country) || "",
      getProductDescription: 0,
      facetFilters: JSON.stringify(facetFilters),
      take: 1,
      skip: 0
    };
    if (collectionId) query.collection = collectionId;
    fetch(usf.settings.searchSvcUrl + "search?" + new URLSearchParams(query).toString())
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (r) {
        done(r && r.data ? r.data.total || 0 : 0);
        renderItemTypePills();
      })
      .catch(function () { done(0); });
  }

  function probeSaleCount() {
    saleProbeSent = true;
    probeCount({ _usf_sale: SALE_FILTER }, function (n) { saleCount = n; });
  }

  function probeNewInCount() {
    if (newInProbeSent || !newInPill || !window.usf || !usf.settings) return;
    newInProbeSent = true;
    probeCount({ _usf_new: ["tags", [newInPill.tag]] }, function (n) { newInCount = n; });
  }

  function installSaleFilter() {
    if (!salePill || !window.usf || !usf.utils || !usf.utils.send || !usf.settings) return;
    // Special Prices category pages are all sale already and filter USF themselves.
    if (document.querySelector("[data-sale-listing-context]")) return;
    // Normally already wrapped by snippets/usf.liquid before USF's first
    // search; this is the fallback for a page without that hook.
    if (usf.utils.send.__bsSale) {
      if (!saleProbeSent) probeSaleCount();
      return;
    }
    var original = usf.utils.send;
    var searchUrl = usf.settings.searchSvcUrl + "search";
    var wrapped = function (config) {
      if (config && config.url === searchUrl && config.data) {
        if (saleFilterOn()) config.data.facetFilters = withSaleFilter(config.data.facetFilters);
      }
      return original.apply(this, arguments);
    };
    wrapped.__bsSale = true;
    usf.utils.send = wrapped;
    if (!saleProbeSent) probeSaleCount();
  }

  /* All / New In / On Sale / a category are one choice: picking one drops
     the others. Written to the URL in a single step - the sale / new params
     plus USF's own Item Type param (uff_<id base 36>_<field>, the form its
     setter writes) - so USF runs one search, not two. kind: "all" | "new" |
     "sale" | "item" (with value). */
  function selectPill(kind, value) {
    var url = new URL(window.location.href);
    var facet = usfItemTypeFacet();
    if (facet) {
      var param = "uff_" + parseInt(facet.id, 10).toString(36) + "_" + facet.facetName;
      url.searchParams.delete(param);
      if (kind === "item") url.searchParams.set(param, value);
    }
    if (kind === "sale") url.searchParams.set(SALE_PARAM, "1");
    else url.searchParams.delete(SALE_PARAM);
    if (kind === "new") url.searchParams.set(NEW_PARAM, "1");
    else url.searchParams.delete(NEW_PARAM);
    url.searchParams.delete("page");
    // USF reads %20, not URLSearchParams' "+", for a space in a value.
    var query = url.searchParams.toString().replace(/\+/g, "%20");
    window.history.pushState({}, "", url.pathname + (query ? "?" + query : "") + url.hash);
  }

  /* While a pill's new results load, the grid dims (listing.css
     .is-refreshing) so the change reads as deliberate. Cleared when USF
     reports the new results, or after 5s whatever happens. */
  var refreshTimer = null, refreshBound = false;
  function markRefreshing() {
    var root = byId("plpRoot");
    if (!root) return;
    root.classList.add("is-refreshing");
    function done() {
      root.classList.remove("is-refreshing");
      clearTimeout(refreshTimer);
    }
    if (!refreshBound && window.usf && usf.event && usf.event.add) {
      refreshBound = true;
      usf.event.add("sr_updated", done);
    }
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(done, 5000);
  }

  function salePillHtml() {
    if (!salePill) return "";
    var on = saleFilterOn();
    if (!on && !(saleCount > 0)) return "";
    return '<button type="button" class="plp-subcat plp-subcat--sale' + (on ? " is-active" : "") + '" data-sale-pill aria-pressed="' + on + '">' +
      escapeHtml(salePill.label || (window.BS_I18N || {}).on_sale || "Special Prices") + "</button>";
  }

  // Styled like All (the plain navy-when-picked pill), pinned beside it.
  function newInPillHtml() {
    if (!newInPill) return "";
    var on = newInFilterOn();
    if (!on && !(newInCount > 0)) return "";
    return '<button type="button" class="plp-subcat' + (on ? " is-active" : "") + '" data-new-in-pill aria-pressed="' + on + '">' +
      escapeHtml((window.BS_I18N || {}).new_in_pill || "New In") + "</button>";
  }

  // Builds the head-band quick-filter pills from USF's live Item Type facet.
  // Runs from watchUsfFilters's MutationObserver (below), so it naturally
  // re-syncs whenever USF (re)renders the sidebar — first when the facet
  // data finishes loading from USF's own backend (nothing to render until
  // then), and again after every filter change (values/counts shift as
  // other facets narrow the result set).
  // Swaps the "N items" heading's own title text for the selected item
  // type's label (e.g. "All Women Clothing" -> "Scarves"), restoring the
  // real collection title when label is falsy. Caches the real title once,
  // before the first-ever override, into a data attribute — later calls
  // must restore *that*, not whatever the heading currently shows (which may
  // already be a previously-selected item type).
  /* Display-only label translation, mirroring snippets/plp-label.liquid so the
     JS-rendered pills and the server-rendered ones read from the same locale
     map. The raw value is what keeps driving the facet query and the data-
     attributes; only the text a shopper sees is swapped, so translating a
     label can never change what a pill filters by.

     Parsed lazily and cached: the item-type map is ~2.5KB of pairs and
     renderItemTypePills re-runs on every USF filter change. An unlisted value
     returns unchanged, so a value with no translation still renders. */
  var bsLabelMaps = {};
  function bsLabelMap(which) {
    if (bsLabelMaps[which]) return bsLabelMaps[which];
    var out = {};
    var raw = (window.BS_I18N || {})[which];
    if (raw) {
      String(raw).split("|").forEach(function (pair) {
        var at = pair.indexOf("=");
        if (at < 1) return;
        var k = pair.slice(0, at).trim().toLowerCase();
        var v = pair.slice(at + 1).trim();
        if (k && v) out[k] = v;
      });
    }
    bsLabelMaps[which] = out;
    return out;
  }
  function bsLabel(raw, which, fallback) {
    var key = String(raw == null ? "" : raw).trim().toLowerCase();
    return bsLabelMap(which)[key] || (fallback === undefined ? raw : fallback);
  }

  function setPlpTitleOverride(label) {
    var titleEl = document.querySelector(".plp-title");
    if (!titleEl || !titleEl.childNodes[0]) return;
    /* Search's <h1> is the query, not a collection name, and its first
       child node is the whitespace before #plpTitleTerm rather than a
       title to swap — writing there would prepend the item type to the
       query. The active type is already shown as a selected pill. */
    if (byId("plpTitleTerm")) return;
    if (titleEl.dataset.originalTitle === undefined) {
      titleEl.dataset.originalTitle = titleEl.childNodes[0].textContent.trim();
    }
    titleEl.childNodes[0].textContent = (label ? label.trim() : titleEl.dataset.originalTitle) + " ";
  }

  function renderItemTypePills() {
    var bar = byId("plpSubcatsBar");
    var wrap = byId("plpQuickFilters");
    if (!bar || !wrap) return;
    installSaleFilter();
    probeNewInCount();
    var saleHtml = newInPillHtml() + salePillHtml();

    var facet = usfItemTypeFacet();
    var ff = (usf.queryRewriter && usf.queryRewriter.facetFilters) || {};

    // Men / Women level (collections set up for it, e.g. /collections/fashion):
    // until a gender is picked the row offers just the gender pills; once one
    // is, it leads the row (tap again to go back) followed by that gender's
    // item types below.
    var gender = usfGenderPillFacet();
    var genderValue = null;
    var genderHtml = "";
    if (gender) {
      var genderNames = (window.BS_I18N || {}).gender_pills || {};
      var genderEntry = ff[gender.facet.id];
      genderValue = genderEntry ? genderEntry[1][0] : null;
      var genderDesktopEl = byId("usf-facet-" + gender.facet.id);
      if (genderDesktopEl) genderDesktopEl.style.setProperty("display", "none", "important");
      gender.labels.forEach(function (v) {
        var isActive = genderValue === v.label;
        if (genderValue && !isActive) return;
        genderHtml +=
          '<button type="button" class="plp-subcat plp-subcat--gender' + (isActive ? " is-active" : "") + '" data-gender-value="' + escapeHtml(v.label) + '"' +
          (isActive ? ' aria-pressed="true"' : "") + ">" +
          escapeHtml(genderNames[String(v.label).trim().toLowerCase()]) +
          (isActive ? ' <span aria-hidden="true">&times;</span>' : "") + "</button>";
      });
      // No gender picked: just the gender pills - unless an item type is
      // still applied (its gender chip was removed, or a shared link), in
      // which case the item types stay on show so it can be seen and undone.
      var itemTypeEntry = facet ? ff[facet.id] : null;
      if (!genderValue && !itemTypeEntry) {
        setPlpTitleOverride(null);
        wrap.innerHTML = genderHtml + saleHtml;
        bar.hidden = false;
        appendQuickfilterArrows(wrap);
        alignActiveQuickfilter(wrap);
        return;
      }
    }

    if (!facet || !facet.labels || !facet.labels.length) {
      if (genderHtml) {
        setPlpTitleOverride(genderNames[String(genderValue).trim().toLowerCase()]);
        wrap.innerHTML = genderHtml + saleHtml;
        bar.hidden = false;
        appendQuickfilterArrows(wrap);
        return;
      }
      bar.hidden = true;
      wrap.innerHTML = "";
      return;
    }
    var activeEntry = ff[facet.id];
    var activeValue = activeEntry ? activeEntry[1][0] : null;

    // Translated for display; activeValue itself stays raw for the facet query.
    setPlpTitleOverride(activeValue != null ? bsLabel(activeValue, "item_type_map") :
      genderValue ? genderNames[String(genderValue).trim().toLowerCase()] : null);

    // The head-band pills now cover Item Type, so hide USF's own duplicate
    // "Item Type" entry in the desktop sidebar (#usf-facet-<id>, inside the
    // #plpFiltersForm subtree this function already re-runs from).
    var desktopFacetEl = byId("usf-facet-" + facet.id);
    // USF's own .usf-facet{display:...} rule has the same specificity as the
    // browser's [hidden]{display:none} default and loads later, so plain
    // `.hidden = true` silently loses that tie — force it with !important.
    if (desktopFacetEl) desktopFacetEl.style.setProperty("display", "none", "important");

    // "All" means the whole collection: lit only when neither a category
    // nor New In / On Sale is picked.
    // All, New In and On Sale sit in a group pinned to the row's start edge
    // (see pinQuickfilters); only the categories scroll.
    var narrowed = !!(activeValue || saleFilterOn() || newInFilterOn());
    var html = genderHtml + '<span class="plp-quickfilters-pinned">' +
      '<button type="button" class="plp-subcat' + (narrowed ? "" : " is-active") + '" data-item-type-all aria-pressed="' + !narrowed + '">' + escapeHtml((window.BS_I18N || {}).all || "All") + '</button>' +
      saleHtml + "</span>";
    facet.labels.forEach(function (v) {
      var label = String(v.label || "").trim();
      if (!label) return;
      var isActive = activeValue === v.label;
      html +=
        '<button type="button" class="plp-subcat' + (isActive ? " is-active" : "") + '" data-item-type-value="' + escapeHtml(v.label) + '" aria-pressed="' + isActive + '">' +
        escapeHtml(bsLabel(label, "item_type_map")) + "</button>";
    });
    wrap.innerHTML = html;
    bar.hidden = false;
    appendQuickfilterArrows(wrap);
    pinQuickfilters(wrap);
    alignActiveQuickfilter(wrap);
  }

  /* The pinned All / On Sale group sits on the ground behind the row (the
     head band, or the white toolbar once initStickyToolbar moves the row
     there) so the categories scrolling beneath it are covered. */
  function pinQuickfilters(wrap) {
    var group = wrap && wrap.querySelector(".plp-quickfilters-pinned");
    if (!group) return;
    var bg = "";
    for (var el = wrap; el && el !== document.documentElement; el = el.parentElement) {
      var c = getComputedStyle(el).backgroundColor;
      if (c && c !== "transparent" && !/rgba\([^)]*,\s*0\)$/.test(c)) { bg = c; break; }
    }
    wrap.style.setProperty("--qf-pin-bg", bg || "#fff");
  }

  /* Keep the selected category at the rail's reading-start edge after a
     filtered collection landing — the left edge in English, the right edge
     in Arabic. This does not reorder the pills: it only moves the
     horizontal viewport, and BS.rtl expresses that as one positive
     distance-from-the-start-edge in both directions.

     Landing flush at the start is the whole point, so there is deliberately
     no inset here any more. The earlier version backed the row off by the
     previous-arrow's width + gap (26 + 12 = 38px) to stop that arrow
     overlaying the pill, which left a sliver of the preceding pill showing
     and made the selected one read as the SECOND item instead of the first.
     Arrow clearance is not worth losing the alignment that was asked for.

     Re-running matters as much as the first run. Three separate things wipe
     this row's scrollLeft after we have set it:
       - renderItemTypePills() reassigns wrap.innerHTML on every USF filter
         state change,
       - initStickyToolbar REPARENTS the row between the subcats bar and the
         toolbar (moving a scroll container resets it to 0),
       - USF resolves the facet asynchronously, so the first call often runs
         while "All" is still the active pill.
     The old one-shot `dataset.alignedActive === key` guard survived all
     three — the flag still said "aligned" while the row sat back at 0,
     so it early-returned and never restored the position. That is why the
     pill sometimes landed correctly and sometimes stayed at the far end.
     The guard now also checks where the row ACTUALLY is, and only re-aligns
     when it has been reset to its origin behind our back — never when the
     shopper has scrolled it themselves. ── */
  function alignActiveQuickfilter(wrap) {
    if (!wrap) return;
    // Prefer a picked category over On Sale when both are lit (an old
    // shared link can carry both).
    var active = wrap.querySelector(".plp-subcat.is-active:not([data-sale-pill]):not([data-new-in-pill])") ||
      wrap.querySelector(".plp-subcat.is-active");
    if (!active) return;

    var key = active.getAttribute("data-item-type-value") ||
      active.getAttribute("data-item-type-param") ||
      (active.hasAttribute("data-item-type-all") || active.hasAttribute("data-native-item-type-all") ? "all" : active.textContent.trim());

    if (wrap.dataset.alignedActive === key) {
      var wanted = parseFloat(wrap.dataset.alignedPos || "0");
      // Nothing to restore (the pill belongs at 0 anyway), or the row is
      // already somewhere other than its origin — which means either our
      // own alignment is still in place, or the shopper moved it. Either
      // way, leave it alone.
      if (wanted <= 2 || BS.rtl.pos(wrap) > 2) return;
    }
    wrap.dataset.alignedActive = key;

    // Two frames, not one: the first call after wrap.innerHTML lands before
    // the new pills have been laid out, so scrollWidth still reads as the
    // old (or zero) content and Math.min below would clamp the target to
    // nothing. Measuring a frame later is what makes the very first landing
    // work rather than needing a filter change to correct itself.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (!active.isConnected) return;

        var wrapRect = wrap.getBoundingClientRect();
        var activeRect = active.getBoundingClientRect();
        var fromStart = BS.rtl.is(wrap)
          ? wrapRect.right - activeRect.right
          : activeRect.left - wrapRect.left;

        var pinned = wrap.querySelector(".plp-quickfilters-pinned");
        if (pinned && pinned.contains(active)) return;
        if (pinned) fromStart -= pinned.getBoundingClientRect().width + 12;

        var target = Math.max(0, Math.min(BS.rtl.max(wrap), BS.rtl.pos(wrap) + fromStart));
        BS.rtl.setPos(wrap, target);
        // Remembered so a later call can tell "the row was reset" apart from
        // "the row is where we put it".
        wrap.dataset.alignedPos = String(target);
        updateQuickfilterArrows(wrap);
      });
    });
  }

  // Scroll-arrow buttons for the category pill row, one per direction —
  // appended as extra flex children of #plpQuickFilters itself (not a
  // separate wrapper) so they survive the sticky-toolbar reparenting
  // (see initStickyToolbar) automatically, whichever container currently
  // holds the row. Idempotent: clears any arrows it previously added
  // before recreating them, since USF's renderItemTypePills() rebuilds
  // wrap.innerHTML (and wipes them) on every facet-state change.
  //
  // `disabled` is what hides an arrow once the row can't travel any further
  // that way — the CSS fades it out rather than removing it, so the row's
  // scrollWidth (and with it the pills' position) never moves. The arrows
  // float over the pills instead of occupying slots, so nothing is reserved.
  function updateQuickfilterArrows(wrap) {
    var left = wrap.querySelector(".plp-quickfilters-arrow-left");
    var right = wrap.querySelector(".plp-quickfilters-arrow-right");
    if (!left && !right) return;
    var canScroll = wrap.scrollWidth > wrap.clientWidth + 2;
    wrap.classList.toggle("has-overflow", canScroll);
    var max = wrap.scrollWidth - wrap.clientWidth - 2;
    var pos = BS.rtl.pos(wrap);
    if (left) left.disabled = pos <= 2;
    if (right) right.disabled = pos >= max;
    // Remembered for buildQuickfilterArrow: renderItemTypePills rebuilds the
    // row (and its arrows) on every filter change.
    wrap._qfArrowsOff = { prev: !!(left && left.disabled), next: !!(right && right.disabled) };
  }

  function appendQuickfilterArrows(wrap) {
    if (!wrap) return;
    wrap.querySelectorAll(".plp-quickfilters-arrow, .plp-quickfilters-nav").forEach(function (el) { el.remove(); });

    // A row with All / On Sale pinned at its start: the back arrow rides in
    // that group (listing.css hangs it just past the group's rule) and the
    // forward arrow sits at the far end (.plp-quickfilters-nav), so each
    // end of the scrolling part has its own. Otherwise: left first in the
    // DOM so tab order follows what the eye sees - CSS `order` pins each
    // one to its end of the row.
    var pinnedGroup = wrap.querySelector(".plp-quickfilters-pinned");
    if (pinnedGroup) {
      pinnedGroup.appendChild(buildQuickfilterArrow(wrap, -1));
      var nav = document.createElement("span");
      nav.className = "plp-quickfilters-nav";
      nav.appendChild(buildQuickfilterArrow(wrap, 1));
      wrap.appendChild(nav);
    } else {
      wrap.insertBefore(buildQuickfilterArrow(wrap, -1), wrap.firstChild);
      wrap.appendChild(buildQuickfilterArrow(wrap, 1));
    }

    if (!wrap.dataset.arrowScrollBound) {
      wrap.dataset.arrowScrollBound = "true";
      wrap.addEventListener("scroll", function () { updateQuickfilterArrows(wrap); }, { passive: true });
      window.addEventListener("resize", function () { updateQuickfilterArrows(wrap); });
    }
    updateQuickfilterArrows(wrap);
  }

  // direction: -1 for the previous arrow, 1 for the next one. The class names
  // keep saying left/right because the stylesheet pins them with `order`; what
  // changes in RTL is which way the chevron points, since flex order already
  // moves the "left" button to the right-hand end.
  function buildQuickfilterArrow(wrap, direction) {
    var isPrev = direction < 0;
    var pointsLeft = BS.rtl.is(wrap) ? !isPrev : isPrev;
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className =
      "plp-quickfilters-arrow plp-quickfilters-arrow-" + (isPrev ? "left" : "right");
    // previous/next rather than left/right: the label stays true either way.
    btn.setAttribute("aria-label", "Scroll categories " + (isPrev ? "back" : "forward"));
    // Start in the state the previous arrow was in (hidden "back" arrow on a
    // fresh row). A new button defaults to enabled, so without this a hidden
    // arrow flashed in and faded out again on every pill click.
    var off = wrap._qfArrowsOff;
    btn.disabled = off ? (isPrev ? off.prev : off.next) : isPrev;
    btn.innerHTML =
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="' +
      (pointsLeft ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7") +
      '"/></svg>';
    btn.addEventListener("click", function () {
      // Most of a row's visible width per click (was a fixed 140px, which
      // took many clicks to cross a long row).
      BS.rtl.by(wrap, direction * Math.max(160, Math.round(wrap.clientWidth * 0.6)), true);
    });
    return btn;
  }

  // Native (no-USF) template's pills are rendered once, server-side, and
  // never have their innerHTML rebuilt (only active-class toggling) — so
  // unlike the USF path above, they only need the arrows added once.
  function initQuickfilterArrows() {
    var wrap = byId("plpQuickFilters");
    if (!wrap || wrap.dataset.arrowsInit) return;
    if (wrap.children.length && !wrap.querySelector(".plp-quickfilters-arrow")) {
      wrap.dataset.arrowsInit = "true";
      appendQuickfilterArrows(wrap);
    }
    alignActiveQuickfilter(wrap);
  }

  // Mobile's "Item Type" facet lives in a completely separate Vue mount —
  // USF appends a lazily-created .usf-facets--mobile node straight onto
  // <body> the first time the mobile filter trigger is tapped (confirmed:
  // it doesn't exist in the DOM until then), so #plpFiltersForm's own
  // MutationObserver (watchUsfFilters) never sees it. Hide the "Item Type"
  // row from that facet-name list here instead of the desktop-only id
  // lookup above — same reasoning (head-band pills already cover it).
  function hideMobileItemTypeFacetRow() {
    var list = document.querySelector(".usf-facets--mobile");
    if (!list) return;
    var titles = list.querySelectorAll(".usf-title");
    // relabelMobileFacetTitles may already have translated the row.
    var itemTypeLocal = ((window.BS_I18N || {}).facet_titles || {})["item type"];
    for (var i = 0; i < titles.length; i++) {
      var text = titles[i].textContent.trim();
      if (text === "Item Type" || (itemTypeLocal && text === itemTypeLocal)) {
        var row = titles[i].closest(".usf-facet-value");
        if (row) row.style.setProperty("display", "none", "important");
      }
    }
  }

  // The search app's facet titles ("Brand", "Gender", "Price") are set in
  // its own admin in English only; show the storefront's translation in the
  // mobile filter panel (list rows and the drilled-in header). Only text
  // that differs is written, so the MutationObserver below does not loop.
  function relabelMobileFacetTitles() {
    var map = (window.BS_I18N || {}).facet_titles || {};
    var list = document.querySelector(".usf-facets--mobile");
    if (!list) return;
    var titles = list.querySelectorAll(".usf-title");
    for (var i = 0; i < titles.length; i++) {
      var local = map[titles[i].textContent.trim().toLowerCase()];
      if (local && titles[i].textContent !== local) titles[i].textContent = local;
    }
  }

  function watchUsfMobileFacets() {
    if (!("MutationObserver" in window)) return;
    var scheduled = false;
    var innerObserved = null;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        hideMobileItemTypeFacetRow();
        relabelMobileFacetTitles();
        // .usf-facets--mobile itself only exists after the first mobile
        // filter-drawer open — once it appears, also observe its own
        // subtree so drilling in/out (which re-renders the row list) keeps
        // the hide applied.
        var list = document.querySelector(".usf-facets--mobile");
        if (list && list !== innerObserved) {
          innerObserved = list;
          new MutationObserver(schedule).observe(list, { childList: true, subtree: true });
        }
      });
    }
    // childList-only (no subtree) on <body> itself is cheap and sufficient
    // to notice .usf-facets--mobile getting appended as a direct child.
    new MutationObserver(schedule).observe(document.body, { childList: true });
  }

  // Native collection.filters equivalent (collection-no-usf template): the
  // pills mirror a subset of the real "Item Type" sidebar checkboxes
  // (rendered server-side, see sections/collection-no-usf.liquid), so
  // clicking one just checks the matching checkbox and reuses the existing
  // AJAX facet refresh — no separate state to reassign. groupParams (all of
  // this facet's param names, from data-item-type-params) get unchecked
  // first since native filters don't have single-select built in the way
  // USF's "multiple: 0" facets do.
  function applyNativeItemTypeFilter(param) {
    var form = byId("plpFiltersForm");
    var wrap = byId("plpQuickFilters");
    if (!form || !wrap) return;
    var groupParams = (wrap.dataset.itemTypeParams || "").split(",").filter(Boolean);
    groupParams.forEach(function (p) {
      var input = form.querySelector('input[name="' + p + '"]');
      if (input) input.checked = false;
    });
    var label = null;
    if (param) {
      var target = form.querySelector('input[name="' + param + '"]');
      if (target) target.checked = true;
      var pill = wrap.querySelector('[data-item-type-param="' + param + '"]');
      if (pill) label = pill.textContent.trim();
    }
    setPlpTitleOverride(label);
    triggerFormRefresh();
  }

  /* USF's own "instant search" re-search (already on /search, typing a new
     term) re-renders the grid client-side via #usf_container but never
     touches our Liquid-rendered title/count — they're outside its mount
     scope, so they'd otherwise freeze on whatever term last loaded the page
     for real. The URL query string is always correct even when USF's own
     render lags, so re-derive both from location.search instead of trying
     to read USF's internal state. */
  function syncPlpTitleFromUrl() {
    var termEl = byId("plpTitleTerm");
    if (!termEl) return;
    var titleWrap = termEl.closest(".plp-title");
    var fallback = titleWrap ? titleWrap.dataset.fallbackTitle : "";
    var term = new URLSearchParams(location.search).get("q");
    termEl.textContent = term ? "“" + term + "”" : fallback || "";
  }

  /* ── In-grid media tiles ──────────────────────────────────────
     A collection's own videos/images (its custom.plp_grid_* metafields, see
     snippets/plp-grid-media.liquid) shown inside the product grid, each after
     a card position of its own. USF renders that grid client-side and
     re-renders it on every facet change, so each tile ships as an inert
     <template data-plp-grid-media-tpl data-after="N"> (sections/
     collection.liquid) and is cloned into position from the pass list below —
     the same way every other USF-render fix in this file re-applies itself.
     No templates exist unless the collection actually has the metafields set,
     so this is a no-op on every other collection.

     Idempotent on purpose: it writes nothing when the tiles already sit where
     they belong, so it can't trip the very MutationObserver that called it
     into an endless re-insert loop. */
  function injectGridMedia(scope) {
    var tpls = document.querySelectorAll("template[data-plp-grid-media-tpl]");
    if (!tpls.length) return;

    // .plp-grid is USF's results wrapper (assets/usf-custom.js adds the class
    // in grid view). Scoped to #usf_container when this runs without one
    // (initAll's first call, before USF has rendered): a landing-style section
    // on the same page can carry its own .plp-grid, and the tiles belong in
    // the PLP's grid, not that one.
    var root = scope || byId("usf_container");
    var grid = root && root.querySelector(".plp-grid");
    if (!grid) return;

    // Count product cards only: USF's own grid banners (.usf-grid-banner) and
    // our tiles are siblings in the same grid and must not shift the positions.
    var cards = grid.querySelectorAll(":scope > .plp-card");

    // Group by position first. Two tiles sharing one position is a merchant
    // slip rather than a design, but handling them as a group is what keeps
    // this convergent: placed one at a time against a moving reference they'd
    // each shove the other aside on every pass, forever.
    var groups = {};
    Array.prototype.forEach.call(tpls, function (tpl) {
      if (!tpl.content || !tpl.content.firstElementChild) return;
      var after = parseInt(tpl.dataset.after, 10);
      // Mirrors the "Show after this many products" schema default.
      if (!(after > 0)) after = 4;
      (groups[after] = groups[after] || []).push(tpl);
    });

    Object.keys(groups).forEach(function (key) {
      var after = parseInt(key, 10);
      var group = groups[key];
      var nodes = group.map(function (tpl) {
        return grid.querySelector(':scope > [data-plp-grid-media="' + tpl.dataset.key + '"]');
      });

      // Fewer products than the cut-off (a narrow filter result): a tile
      // hanging off the end of a short grid reads as a broken card, so pull it
      // until enough products come back.
      if (cards.length <= after) {
        nodes.forEach(function (node) { if (node) node.remove(); });
        return;
      }

      // The (N+1)th card, i.e. the one this group sits in front of. Deliberately
      // not cards[after - 1].nextSibling: that reference shifts as soon as a
      // tile lands next to the Nth card, and the group would never settle.
      var ref = cards[after];

      // Already in place — every tile present, in template order, immediately
      // ahead of that card. Bail without touching the DOM.
      var settled = nodes.every(function (node, i) {
        return node && node.nextSibling === (nodes[i + 1] || ref);
      });
      if (settled) return;

      group.forEach(function (tpl, i) {
        var node = nodes[i];
        if (node) {
          // USF's Vue re-render inserts its own cards around our unmanaged
          // nodes and can leave them a slot or two out of place. Move the same
          // node rather than rebuilding it, so a playing video isn't restarted.
          grid.insertBefore(node, ref);
          return;
        }
        node = tpl.content.firstElementChild.cloneNode(true);
        grid.insertBefore(node, ref);
        initGridMediaVideo(node);
      });
    });
  }

  /* Autoplay is driven from here rather than the plain `autoplay` attribute:
     the tile sits mid-grid, so a visitor who never scrolls to it shouldn't pay
     for the download (preload="none" in the snippet holds the first byte until
     this asks for it), and one who scrolls past shouldn't keep decoding
     frames off screen. */
  function initGridMediaVideo(tile) {
    var video = tile.querySelector("video[data-plp-autoplay]");
    if (!video || video.dataset.plpAutoplayBound) return;
    video.dataset.plpAutoplayBound = "true";

    // Reduced-motion visitors get a still poster with controls instead of a
    // looping video they didn't ask to start — the same courtesy the spinner
    // and card hover transitions already extend in listing.css.
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      video.controls = true;
      video.preload = "metadata";
      return;
    }
    // Set the property, not just the markup attribute: muted is what makes
    // programmatic play() allowed without a user gesture, and it's the one
    // thing worth not trusting a cloneNode to have carried over.
    video.muted = true;

    function play() {
      var played = video.play();
      // Rejects when the tab is backgrounded or the gesture policy still
      // isn't satisfied — swallow it and leave the poster showing.
      if (played && typeof played.catch === "function") played.catch(function () {});
    }

    if (!("IntersectionObserver" in window)) {
      play();
      return;
    }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) play();
        else if (!video.paused) video.pause();
      });
    }, { rootMargin: "200px 0px" }).observe(video);
  }

  function watchUsfGrid() {
    if (!("MutationObserver" in window)) return;
    var scheduled = false;
    var innerObserved = null;
    var bootstrapObserver = null;

    // Each pass isolated rather than sharing one try block: these helpers race
    // against USF's own async rendering (card images and variants JSON landing
    // at different moments) and are known to throw intermittently — see the
    // same note in initPlp. Sharing a block meant one throw skipped every pass
    // after it, and renderSwatchThumbnails sits in the middle of the list.
    var PASSES = [
      function (c) { stripBrandPrefixes(c); },
      function (c) { tagQuickaddState(c); },
      function (c) { relabelQuickaddButtons(c); },
      function (c) { iconizeQuickviewButtons(c); },
      function (c) { layoutCardInfo(c); },
      function (c) { syncMainImageToActiveSwatch(c); },
      function (c) { renderSwatchThumbnails(c); },
      function (c) { markSwatchAvailability(c); },
      function (c) { injectGridMedia(c); },
      function () { equalizeCardHeights(); },
      function () { updateFilterBadgeFromUsf(); },
      function () { renderMobileFilterChips(); },
      function () { syncPlpCountFromUsf(); },
      function () { syncPlpTitleFromUrl(); }
    ];

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        var container = innerObserved || byId("usf_container");
        if (!container) return;

        // Attach the observers BEFORE running any pass. They used to be wired
        // up at the end of this callback, after the whole unguarded pass list,
        // so a single intermittent throw meant they were never attached at
        // all — and since nothing else re-checks, that page could never patch
        // its swatches again. That is the "images on the first load, flat
        // broken chips after a few refreshes" flake: the race only throws
        // some of the time.
        if (container !== innerObserved) {
          innerObserved = container;
          new MutationObserver(schedule).observe(container, { childList: true, subtree: true });
          watchSwatchAttributes(container);
          // Bootstrap watch has done its job; keep it from re-running these
          // passes for every unrelated DOM change on the page.
          if (bootstrapObserver) {
            bootstrapObserver.disconnect();
            bootstrapObserver = null;
          }
        }

        for (var i = 0; i < PASSES.length; i++) {
          try {
            PASSES[i](container);
          } catch (err) {
            if (window.console && console.error) console.error("PLP USF grid pass failed:", err);
          }
        }
      });
    }

    // subtree is required, not optional: #usf_container sits several levels
    // below <body>, so a childList-only watch here never fired at all and the
    // "container created late" fallback silently did nothing. Disconnected as
    // soon as the container is found, so the broad watch is bootstrap-only.
    bootstrapObserver = new MutationObserver(schedule);
    bootstrapObserver.observe(document.body, { childList: true, subtree: true });
    schedule();
  }

  /* ── Keep swatch thumbnails applied when USF re-renders in place ──
     USF's grid is Vue, and its swatch row comes from a server-supplied HTML
     string (result.color_template, injected with v-html) that still carries
     the broken `background-color: 3286-ANTA`-style fallback. Vue frequently
     patches those existing buttons in place — rewriting only their class and
     style attributes, adding/removing no nodes at all — which silently wiped
     renderSwatchThumbnails' work. The grid observer above is
     childList/subtree only, so it never fired for that, and the swatches
     stayed broken until something else happened to re-render the whole row:
     the "sometimes images, sometimes blank chips" flip-flop.

     Deliberately a separate observer from the one above, watching only class
     and style, and re-running only the (idempotent) swatch pass: the heavy
     pass sets inline styles of its own via layoutCardInfo /
     equalizeCardHeights, so routing attribute mutations into it would mean
     every layout write scheduled another full pass. ─────────────────────── */
  function watchSwatchAttributes(container) {
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        // Safe against self-triggering: renderSwatchThumbnails leaves
        // already-correct buttons untouched, so a pass with nothing to fix
        // writes nothing and produces no further mutations.
        renderSwatchThumbnails(container);
      });
    });
    observer.observe(container, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style"],
    });
  }

  /* ── Active-filter chips: USF renders its own "X removed" pill
     breadcrumb (.usf-refineby) inside the filter sidebar's Vue root
     (#plpFiltersForm), but the design wants it next to "Show filters"
     in the toolbar instead — a different, Liquid-rendered part of the
     page CSS can't reach across. Physically re-parent the node into
     #plpActiveFilters whenever USF (re)renders it. ─────────────────── */
  function relocateActiveFilters() {
    // Not scoped to #plpFiltersForm: after the first relocation the
    // breadcrumb lives in #plpActiveFilters instead, and USF replaces (not
    // patches) its .usf-refineby__item children when the selected value
    // changes — scoping the lookup to its original mount point meant every
    // call after the first one silently found nothing to re-hide.
    var breadcrumb = document.querySelector(".usf-refineby");
    var slot = byId("plpActiveFilters");
    if (breadcrumb && slot && breadcrumb.parentElement !== slot) {
      slot.appendChild(breadcrumb);
    }
    hideItemTypeChip(breadcrumb);
  }

  // Item Type already has its own active state on the head-band pills, so
  // its "Item Type: Scarves ×" entry in this breadcrumb would just be a
  // redundant second place to see/clear the same selection — hide only that
  // one chip, same !important reasoning as hideMobileItemTypeFacetRow.
  // Guarded on display !== "none" so switching values (which resets this via
  // a style-attribute write, see watchUsfFilters) doesn't loop against the
  // attribute observer that re-triggers this same function.
  function hideItemTypeChip(breadcrumb) {
    if (!breadcrumb) return;
    var items = breadcrumb.querySelectorAll(".usf-refineby__item");
    // Gender too where the Men / Women pills show it (and undo it with ×).
    var hideGender = !!usfGenderPillFacet();
    for (var i = 0; i < items.length; i++) {
      var label = items[i].querySelector(".usf-filter-label");
      var name = label ? label.textContent.trim().replace(/:$/, "") : "";
      if ((name === "Item Type" || (hideGender && name === "Gender")) && items[i].style.display !== "none") {
        items[i].style.setProperty("display", "none", "important");
      }
    }
  }

  function watchUsfFilters() {
    var form = byId("plpFiltersForm");
    if (!form || !("MutationObserver" in window)) return;
    var scheduled = false;
    var slotObserved = false;
    function run() {
      relocateActiveFilters();
      renderItemTypePills();
      // Once the breadcrumb has been relocated into #plpActiveFilters, it's
      // outside #plpFiltersForm's subtree — Vue can still update it in place
      // afterwards (e.g. switching from one Item Type value to another),
      // which this function's own observer would then miss entirely. Watch
      // the new home too, once it exists, so hideItemTypeChip keeps
      // re-applying after every such in-place update.
      if (!slotObserved) {
        var slot = byId("plpActiveFilters");
        if (slot) {
          slotObserved = true;
          new MutationObserver(schedule).observe(slot, watchOpts);
        }
      }
    }
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        run();
      });
    }
    // attributes/style: switching Item Type values doesn't just change text —
    // USF toggles this chip's visibility via a v-show-style inline
    // style.display write, which childList/subtree alone won't catch, and
    // which also clobbers hideItemTypeChip's own !important override each
    // time it happens.
    var watchOpts = { childList: true, subtree: true, attributes: true, attributeFilter: ["style"] };
    var observer = new MutationObserver(schedule);
    observer.observe(form, watchOpts);
    run();
  }

  /* ── Card media: swatches / sizes / gallery dots ─────────── */
  // Price shown on the card is product.price_min/compare_at_price_min —
  // set once at render, for the product as a whole, never the specific
  // colour+size actually selected. Re-derive it from whichever variant
  // currently matches both active selections (colour, size — either may
  // be unset) and rebuild the price markup, same .now/.was structure the
  // templates render so existing CSS still applies untouched.
  function syncCardPriceFromSelection(card) {
    var priceBox = card.querySelector(".plp-card-price");
    if (!priceBox) return;
    var color = card.querySelector("[data-swatch].is-active");
    var size = card.querySelector("[data-size].is-active");
    var variant = findVariant(getVariants(card), color ? color.dataset.value : null, size ? size.dataset.value : null);
    if (!variant) return;
    var hasSale = !!variant.compare_price_html;
    priceBox.innerHTML =
      (hasSale ? '<span class="was">' + variant.compare_price_html + "</span>" : "") +
      '<span class="' + (hasSale ? "now" : "") + '">' + variant.price_html + "</span>";
  }

  function selectSwatch(btn) {
    var card = btn.closest("[data-product-card]");
    var group = btn.parentElement;
    if (!card || !group) return;

    Array.prototype.forEach.call(group.querySelectorAll("[data-swatch]"), function (b) {
      b.classList.toggle("is-active", b === btn);
    });

    var img = card.querySelector("[data-card-img-main]");
    if (img && btn.dataset.image) {
      img.src = btn.dataset.image;
      img.removeAttribute("srcset");
    }

    // Hover-swap image was always the product's generic 2nd photo,
    // regardless of which colour was selected — data-hover-image (that
    // colour's own second distinct photo, set by the same templates) keeps
    // it matching the current swatch. Falls back to the colour's single
    // main photo (a no-op hover) rather than an unrelated generic one when
    // that colour has no second photo of its own.
    var hoverImg = card.querySelector(".plp-card-hoverimg");
    if (hoverImg && btn.dataset.image) {
      hoverImg.src = btn.dataset.hoverImage || btn.dataset.image;
      hoverImg.removeAttribute("srcset");
    }

    if (btn.dataset.variantId) {
      ["[data-card-media]", ".plp-card-name"].forEach(function (sel) {
        var link = card.querySelector(sel);
        if (!link) return;
        var base = link.getAttribute("href").split("?")[0];
        link.setAttribute("href", base + "?variant=" + btn.dataset.variantId);
      });
    }

    syncCardPriceFromSelection(card);
  }

  function selectSize(btn) {
    var card = btn.closest("[data-product-card]");
    var group = btn.parentElement;
    if (!group) return;
    var alreadyActive = btn.classList.contains("is-active");
    Array.prototype.forEach.call(group.querySelectorAll("[data-size]"), function (b) {
      b.classList.remove("is-active");
    });
    if (!alreadyActive) btn.classList.add("is-active");
    if (card) syncCardPriceFromSelection(card);
  }

  function selectDot(btn) {
    var card = btn.closest("[data-product-card]");
    if (!card) return;
    Array.prototype.forEach.call(card.querySelectorAll("[data-dot]"), function (b) {
      b.classList.toggle("is-active", b === btn);
    });
    var img = card.querySelector("[data-card-img-main]");
    if (img && btn.dataset.src) {
      img.src = btn.dataset.src;
      img.removeAttribute("srcset");
    }
  }

  function promptSizeSelection(card) {
    var sizes = card.querySelector(".plp-sizes");
    if (!sizes) return;
    sizes.style.opacity = "1";
    sizes.style.outline = "2px solid var(--color-primary)";
    sizes.style.outlineOffset = "3px";
    sizes.scrollIntoView({ block: "nearest", behavior: "smooth" });
    setTimeout(function () {
      sizes.style.outline = "";
      sizes.style.outlineOffset = "";
      sizes.style.opacity = "";
    }, 1200);
  }
window._usf_promptSizeSelection = promptSizeSelection;
  /* ── Cart: add via Ajax API + confirmation modal ─────────── */
  /* Shared floating notice — the PLP counterpart of the PDP's showToast
     (assets/product.js). Two looks, matching the PDP: the default is a
     centred confirmation pill (e.g. a wishlist add), and isError swaps it
     for a full-bleed red band pinned under the header for a refused add.
     Shown on every viewport, not just mobile as the PDP's confirmations
     are: the trigger can be any card anywhere in the grid or the Quick
     View drawer, so there's no in-flow spot near the button that's
     reliably on screen. Markup: snippets/plp-toast.liquid. */
  var toastTimer = null;

  function showToast(message, isError, icon) {
    var toast = byId("plpToast");
    var text = byId("plpToastText");
    if (!toast || !text) return;
    text.textContent = message;
    var iconEl = byId("plpToastIcon");
    // Errors are the full-width red band — always plain, no icon; the pill
    // confirmations get a champagne-gold glyph (heart for wishlist).
    if (iconEl) iconEl.innerHTML = isError ? "" : (icon || "");
    toast.classList.toggle("is-error", !!isError);
    toast.setAttribute("role", isError ? "alert" : "status");
    toast.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove("is-visible");
    }, isError ? 5000 : 2500);
  }

  // Champagne-gold heart glyphs for the wishlist confirmation pill — filled
  // on add, outline on remove. Shares the QV heart's path for a consistent
  // silhouette across the page.
  var WISH_ICON_ADDED =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" ' +
    'stroke="currentColor" stroke-width="1.6" stroke-linejoin="round">' +
    '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>';
  var WISH_ICON_REMOVED =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>';

  /* ── Mobile "added to your bag" card (snippets/plp-cart-toast.liquid) ──
     Shown on mobile in place of the cart drawer preview: fills in the
     added product's image/title/variant from the /cart/add.js line item,
     then auto-dismisses. `item` is data.items[0]; falls back to the drawer
     preview if the markup or item is missing so an add is never silent. */
  var cartToastTimer = null;
  var CART_TOAST_MS = 2000;

  // The card markup (snippets/plp-cart-toast.liquid) is server-rendered on the
  // collection pages, but listing.js also drives quick-add on the search page,
  // homepage grids, PDP recommendations and cart-page recommendations — none of
  // which render it. Build it on demand there (once) so the mobile confirmation
  // card works on every page, not just the PLP. listing.css is loaded wherever
  // listing.js runs, so the injected node is styled the same everywhere.
  function ensureCartToast() {
    if (byId("plpCartToast")) return;
    var el = document.createElement("div");
    el.className = "plp-cart-toast";
    el.id = "plpCartToast";
    el.setAttribute("role", "status");
    el.setAttribute("aria-live", "polite");
    el.setAttribute("aria-hidden", "true");
    el.innerHTML =
      '<div class="plp-cart-toast-media">' +
        '<img class="plp-cart-toast-img" id="plpCartToastImg" src="" alt="" width="64" height="80" loading="lazy">' +
      "</div>" +
      '<div class="plp-cart-toast-body">' +
        '<p class="plp-cart-toast-eyebrow">' +
          '<span class="plp-cart-toast-check" aria-hidden="true">' +
            '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
          "</span>Added to your bag</p>" +
        '<p class="plp-cart-toast-title" id="plpCartToastTitle"></p>' +
        '<p class="plp-cart-toast-meta" id="plpCartToastMeta" hidden></p>' +
      "</div>" +
      '<span class="plp-cart-toast-progress" id="plpCartToastBar" aria-hidden="true"></span>';
    document.body.appendChild(el);
  }

  function showCartToast(item) {
    if (!item) {
      if (window.BS_showCartPreview) window.BS_showCartPreview();
      return;
    }
    ensureCartToast();
    var toast = byId("plpCartToast");
    if (!toast) {
      if (window.BS_showCartPreview) window.BS_showCartPreview();
      return;
    }
    var img = byId("plpCartToastImg");
    var title = byId("plpCartToastTitle");
    var meta = byId("plpCartToastMeta");
    var bar = byId("plpCartToastBar");
    var src = (item.featured_image && item.featured_image.url) || item.image || "";
    if (img) {
      img.removeAttribute("srcset");
      img.src = src;
      img.alt = item.product_title || item.title || "";
    }
    if (title) title.textContent = item.product_title || item.title || "";
    if (meta) {
      // "Default Title" is Shopify's placeholder for a variant-less product.
      var variant = item.variant_title && item.variant_title !== "Default Title"
        ? item.variant_title : "";
      meta.textContent = variant;
      meta.hidden = !variant;
    }
    toast.setAttribute("aria-hidden", "false");
    toast.classList.add("is-visible");
    // Countdown bar: snap to full width, then drain to empty over the
    // dismiss window. Reflow between the two so it re-runs on every add.
    if (bar) {
      bar.style.transition = "none";
      bar.style.transform = "scaleX(1)";
      void bar.offsetWidth;
      bar.style.transition = "transform " + CART_TOAST_MS + "ms linear";
      bar.style.transform = "scaleX(0)";
    }
    clearTimeout(cartToastTimer);
    cartToastTimer = setTimeout(function () {
      toast.classList.remove("is-visible");
      toast.setAttribute("aria-hidden", "true");
    }, CART_TOAST_MS);
  }

  /* Per-card refused-add message, shown as a band over the card's own image
     instead of the full-width fixed .plp-toast — used by the card's direct
     "Add to cart" (quickAddDirect) so the shopper sees which product it's
     about. Auto-dismisses; the node is removed after it fades so it never
     lingers in the swapped-in USF grid markup. */
  function showCardOos(card, message) {
    var media = card && card.querySelector(".plp-card-media");
    if (!media) { showToast(message, true); return; }
    var el = media.querySelector(".plp-card-oos");
    if (!el) {
      el = document.createElement("div");
      el.className = "plp-card-oos";
      el.setAttribute("role", "alert");
      media.appendChild(el);
    }
    el.textContent = message;
    clearTimeout(el._oosTimer);
    // Reflow so the transition runs even when the node was just created.
    void el.offsetWidth;
    el.classList.add("is-visible");
    el._oosTimer = setTimeout(function () {
      el.classList.remove("is-visible");
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 320);
    }, 4000);
  }

  // onError(message, status), when passed, overrides the default floating
  // toast — the Quick View uses it to show the message in-flow beneath its
  // Add to bag button instead (see showQvOos).
  function addToCart(variantId, onSuccess, onError) {
    var root = byId("plpRoot");
    var addUrl = (root && root.dataset.cartAddUrl) || storefrontUrl("cart/add.js");
    fetch(addUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          console.error("Add to cart failed:", data.message || data.description);
          // 422 is Shopify refusing on stock: the shopper already holds
          // every unit there is (the common case on a "only 1 left"
          // variant they've already added). Without this the button just
          // quietly does nothing and the add looks broken.
          var msg = data.status === 422
            ? "You've already added this to your bag — that's all we have in stock."
            : "Sorry, we couldn't add that to your bag. Please try again.";
          if (onError) onError(msg, data.status);
          else showToast(msg, true);
          return;
        }
        // Confirmation — covers both the card's own quick-add and Quick
        // View's confirm, since both funnel through this same function.
        // Mobile gets a light auto-dismissing "added to bag" card instead
        // of the full cart drawer (see showCartToast); desktop keeps the
        // brief auto-dismissing cart preview (assets/blue-salon.js). Either
        // path already re-fetches /cart.js and syncs the header count itself
        // (see render()'s syncHeaderCount in blue-salon.js) — updateCartCount()
        // below only runs as a fallback so a plain add never fires that same
        // /cart.js request twice over.
        var added = data.items && data.items[0];
        var headerWillSync = false;
        if (window.matchMedia(CARD_MOBILE_QUERY).matches) {
          showCartToast(added);
          // Keep the (unopened) bag drawer in sync so it's instant + correct
          // when the shopper opens it later — the toast path never opens it.
          if (window.BS_refreshCart) { window.BS_refreshCart(); headerWillSync = true; }
          // Brings the auto-hidden mobile topbar back so the bag count is visible.
          document.dispatchEvent(new CustomEvent("bs:cart:added"));
        } else if (window.BS_showCartPreview) {
          window.BS_showCartPreview();
          headerWillSync = true;
        }
        if (!headerWillSync) updateCartCount();
        if (onSuccess) onSuccess(data);
      })
      .catch(function (err) {
        console.error(err);
        var failMsg = "Sorry, we couldn't add that to your bag. Please try again.";
        if (onError) onError(failMsg, 0);
        else showToast(failMsg, true);
      });
  }

  function updateCartCount() {
    fetch(storefrontUrl("cart.js"), { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("#cartCount").forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }
  window._usf_updateCartCount = updateCartCount;
  // PayLater/loyalty lines are merchant-configurable (section settings), so
  // the copy itself is Liquid-rendered once into #plpRoot's own data
  // attributes; the Quick View drawer fills in the live amount/points and
  // reads it from there.
  function payLaterHTML(installmentHtml) {
    var root = byId("plpRoot");
    var template = root && root.dataset.paylaterTemplate;
    if (!template || !installmentHtml) return "";
    return '<p class="men-quickadd-paylater">' + template.replace("%%AMOUNT%%", installmentHtml) + "</p>";
  }

  function loyaltyHTML(points) {
    var root = byId("plpRoot");
    var template = root && root.dataset.loyaltyTemplate;
    if (!template || typeof points === "undefined") return "";
    var pointsText = typeof points === "number" ? points.toLocaleString() : points;
    return '<div class="men-quickadd-loyalty">' +
      '<img class="men-quickadd-loyalty-badge" src="https://cdn.shopify.com/s/files/1/0370/6444/1991/files/mozoon-icon.png?v=1784118300" alt="Mozoon">' +
      '<p class="men-quickadd-loyalty-text">' + template.replace("%%POINTS%%", pointsText) + "</p>" +
    "</div>";
  }

  /* ── Quick View drawer: opens on "Add to Bag" so the shopper can
     confirm the variant before it's actually added via the Ajax cart API
     (see snippets/quick-view-drawer.liquid).

     The drawer offers EVERY option the product has, not just the colour
     and size the card tile happens to show — it commits to a purchase, so
     an option it doesn't ask about is one the shopper gets assigned. That
     structure can't be read back off the card (the tile renders no Width
     or Volume row, and caps swatches at 3 + "+N"), so product-card.liquid
     publishes it as [data-options-json]. Options are keyed by POSITION,
     the only stable key in Shopify's variant model. ─────────────────── */
  var qvCard = null;       // [data-product-card] currently open in the drawer
  var qvVariants = [];     // that card's parsed variant JSON
  var qvOptions = [];      // [{position, name, is_color, values[]}]

  /* EU / US / UK shoe sizes in the drawer, same rule and chart as the PDP
     (assets/size-switcher.js, exposed as window.BSSizeSwitcher): Cole Haan
     footwear, stored in US sizes. Values, picks and the cart stay in US;
     only the chip labels change. The product's gender comes from its own
     tags/type (/products/<handle>.js, fetched once per product), the same
     inputs the PDP uses. The chosen system is shared with the PDP. */
  var qvSizeSystem = null;   // { gender } while the drawer's product qualifies
  var qvSizeGenderCache = {};

  function qvSizeSystemCurrent() {
    try {
      var stored = window.localStorage.getItem("sizeSystem");
      if (stored === "eu" || stored === "us" || stored === "uk") return stored;
    } catch (e) {}
    return "eu";
  }

  function qvSizeLabel(value) {
    var api = window.BSSizeSwitcher;
    if (!qvSizeSystem || !api) return value;
    return api.convertSize(value, qvSizeSystemCurrent(), qvSizeSystem.gender);
  }

  // Numeric sizes smallest first; anything else keeps its order.
  function qvSortedValues(opt) {
    if (opt.is_color) return opt.values;
    var numeric = opt.values.every(function (v) { return /^\s*\d/.test(String(v.name)); });
    if (!numeric) return opt.values;
    return opt.values
      .map(function (v, i) { return { v: v, i: i, n: parseFloat(String(v.name).replace(",", ".")) }; })
      .sort(function (a, b) { return a.n - b.n || a.i - b.i; })
      .map(function (x) { return x.v; });
  }

  function qvSetupSizeSystem(card) {
    qvSizeSystem = null;
    var api = window.BSSizeSwitcher;
    var brandEl = card.querySelector(".plp-card-brand");
    var vendorKey = (brandEl ? brandEl.textContent : "").toLowerCase().replace(/[\s-]/g, "");
    var sizeOpt = qvOptions.filter(function (o) { return o.is_size; })[0];
    if (!api || vendorKey.indexOf("colehaan") === -1 || !sizeOpt) return;
    var nameEl = card.querySelector(".plp-card-name");
    var href = nameEl ? (nameEl.getAttribute("href") || "").split("?")[0] : "";
    var handle = href.split("/products/")[1];
    if (!handle) return;
    var forCard = card;
    function use(gender) {
      if (qvCard !== forCard || !gender) return;
      // Only when the chart actually covers these values.
      var converts = sizeOpt.values.some(function (v) {
        return api.convertSize(v.name, "eu", gender) !== String(v.name).trim();
      });
      if (!converts) return;
      qvSizeSystem = { gender: gender };
      qvRender();
    }
    if (qvSizeGenderCache[handle] !== undefined) return use(qvSizeGenderCache[handle]);
    fetch(BS.storefrontUrl("products/" + handle + ".js"))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var gender = p ? api.detectGender({ tags: p.tags || [], type: p.type || "" }) : null;
        qvSizeGenderCache[handle] = gender;
        use(gender);
      })
      .catch(function () {});
  }
  var qvSelected = {};     // drawer-local picks, keyed by option position

  function qvPositions() {
    return qvOptions.map(function (o) { return o.position; });
  }

  // The card's own swatch/size row still speaks colour/size, so the
  // drawer has to be able to name those two among the generic set.
  function qvPositionOf(predicate) {
    for (var i = 0; i < qvOptions.length; i++) {
      if (predicate(qvOptions[i])) return qvOptions[i].position;
    }
    return 0;
  }
  function qvColorPos() {
    return qvPositionOf(function (o) { return o.is_color; });
  }
  function qvSizePos() {
    return qvPositionOf(function (o) { return o.is_size || /size/i.test(o.name); });
  }

  var QV_HEART =
    '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>';

  // First variant image for a given option value — used to give a colour
  // swatch a real photo when the value itself published none.
  function qvValueImage(position, value) {
    for (var i = 0; i < qvVariants.length; i++) {
      var v = qvVariants[i];
      if ((v.options || [])[position - 1] === value && v.image) return v.image;
    }
    return null;
  }

  function qvActiveVariant() {
    return findVariantByOptions(qvVariants, qvSelected, qvPositions());
  }

  // Per-value sold-out state, recomputed live from qvVariants. A colour is
  // available when any variant in that colour can be bought; clicking it will
  // re-seed the size. Other options remain contextual to the current picks.
  // This avoids showing an in-stock colour as sold out just because the size
  // currently selected under another colour is not offered there.
  //
  // For contextual options this is recomputed from whatever's
  // currently picked at every OTHER position — unlike val.available (baked
  // once into options_json against whatever variant the card/USF happened to
  // render as default), this reflects the combination the shopper actually has
  // selected right now, so switching colour correctly updates which sizes
  // show as sold out instead of carrying over the previous colour's state.
  function qvValueAvailable(position, value) {
    var option = qvOptions.filter(function (opt) {
      return opt.position === position;
    })[0];
    // The rule this used to spell out inline now lives in the shared
    // resolver, so the PDP and the wishlist drawer apply the same one.
    return window.BSVariants.optionAvailable(
      qvVariants, qvPositions(), qvSelected, position, value, !!(option && option.is_color)
    );
  }

  /* "Low in stock: only N left." in the Quick View — same rule as the PDP's
     note (see applyLowStock in assets/product.js): show it once the selected
     variant is at or below the merchant's threshold. The threshold rides on
     #plpRoot as data-low-stock-threshold, like data-paylater-template does;
     absent or 0 turns it off, so quick-view hosts that don't expose the
     setting (product recommendations, cart, spotlight grid) stay unchanged.
     A variant Shopify isn't tracking has inventory:null and never triggers
     it, so an untracked line can't read as "only 0 left". */
  function qvLowStockHTML(variant) {
    var root = byId("plpRoot");
    var max = root ? parseInt(root.dataset.lowStockThreshold, 10) || 0 : 0;
    var qty = variant && variant.inventory;
    if (!(max > 0 && typeof qty === "number" && qty > 0 && qty <= max)) return "";
    return '<p class="men-quickadd-lowstock">' +
      '<svg class="men-quickadd-lowstock-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>' +
      "<span>" + qvLowStockText(qty) + "</span></p>";
  }

  // Same sentence as the PDP's note (assets/product.js). Arabic does not
  // build it from fragments, so the whole string is one key.
  function qvLowStockText(qty) {
    var T = (window.BS_I18N || {}).product || {};
    if (qty === 1) return T.low_stock_one || "Low in stock: only 1 left.";
    return (T.low_stock_many || "Low in stock: only __COUNT__ left.")
      .replace("__COUNT__", qty);
  }

  // First value of a card's [data-swatch]/[data-size] group whose data-value matches.
  function elByValue(list, value) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].dataset.value === value) return list[i];
    }
    return null;
  }

  // Keeps a card's own swatch/size selection (and its image/href) in sync
  // with whatever colour/size is chosen in the Quick View drawer or the
  // add-to-cart confirmation modal, so the grid reflects the latest pick
  // once either overlay closes.
  function syncCardSelection(card, color, size) {
    if (!card) return;
    var swatch = elByValue(card.querySelectorAll("[data-swatch]"), color);
    if (swatch) selectSwatch(swatch);
    var sizeGroup = card.querySelector(".plp-sizes");
    if (sizeGroup) {
      Array.prototype.forEach.call(sizeGroup.querySelectorAll("[data-size]"), function (b) {
        b.classList.toggle("is-active", b.dataset.value === size);
      });
    }
  }

  function qvRender() {
    var body = byId("menQuickaddBody");
    var card = qvCard;
    if (!body || !card) return;

    var variant = qvActiveVariant();
    var nameEl = card.querySelector(".plp-card-name");
    var brandEl = card.querySelector(".plp-card-brand");
    var name = escapeHtml(nameEl ? nameEl.textContent.trim() : "");
    var href = escapeHtml(nameEl ? nameEl.getAttribute("href").split("?")[0] : "#");
    var mainImg = card.querySelector("[data-card-img-main]");
    var primary = (variant && variant.image) || (mainImg ? mainImg.src : "");
    var productText = (window.BS_I18N && window.BS_I18N.product) || {};

    var gallery = '<div class="men-quickadd-gallery"><img src="' + escapeHtml(primary) + '" alt="' + name + '"></div>';

    var priceHTML = variant ? variant.price_html : "";
    if (variant && variant.compare_price_html) {
      // .now matches the listing card's own sale-price class (see
      // .plp-card-price .now / .men-quickadd-price .now in listing.css) —
      // without it the current price just inherited the price block's
      // plain ink colour instead of the sale-red used on the card.
      priceHTML = '<span class="was">' + variant.compare_price_html + "</span>" +
        '<span class="now">' + priceHTML + "</span>";
    }

    var paylaterLine = variant ? payLaterHTML(variant.installment_html) : "";
    var loyaltyLine = variant ? loyaltyHTML(variant.points) : "";

    // One section per option, built from the card's published option
    // structure rather than from its swatch/size markup — see qvOptions.
    // A colour renders as photo swatches, everything else as chips; that
    // is the only place an option's name still matters here.
    var optionsHTML = qvOptions.map(function (opt) {
      var chosen = qvSelected[opt.position] || "";
      var sizeSwitch = opt.is_size && qvSizeSystem;
      var values = qvSortedValues(opt).map(function (val) {
        var un = !qvValueAvailable(opt.position, val.name);
        var on = val.name === chosen;
        // aria-disabled, not the disabled attribute: a disabled button fires
        // no click at all, so tapping a sold-out swatch produced complete
        // silence. It is still unselectable (onQuickViewBodyClick matches
        // .is-unavailable first and only explains itself), and still
        // announced as disabled — it just isn't inert any more.
        var attrs = ' data-qv-opt="' + opt.position + '" data-qv-value="' + escapeHtml(val.name) + '"' +
          (un ? ' aria-disabled="true"' : "");
        if (opt.is_color) {
          // Same treatment as the card's swatches: a real variant photo
          // where there is one, falling back to the value name as a CSS
          // colour — these products carry no configured Shopify
          // swatch.color, so that fallback is often invalid ("Ice Blue")
          // and simply leaves the chip blank, exactly as on the tile.
          // val.style is the tile's own inline style, carried over on
          // USF-rendered cards; val.thumb is the published variant photo.
          // Image fallback chain, mirroring the PDP's
          // renderSwatchThumbnails: the value's own published photo, then
          // any variant carrying this value, then the card's main image.
          // The last resort matters — these products have no configured
          // Shopify swatch.color, so a name like "BLACK/BLACK" isn't
          // valid CSS and left the chip blank.
          var thumb = val.thumb || qvValueImage(opt.position, val.name) || primary;
          // Built raw and escaped once at insertion below — val.style is
          // the tile's literal style attribute, so it must go through the
          // same escaping as any URL we compose ourselves.
          var style = val.style ||
            (thumb
              ? "background-image:url('" + thumb + "')"
              : "background-color:" + String(val.name).replace(/\s+/g, ""));
          var availabilityText = un ? (productText.sold_out_paren || "(Sold out)") : "";
          var accessibleName = val.name + (availabilityText ? " " + availabilityText : "");
          return '<button type="button" class="men-quickadd-swatch' +
            (style.indexOf("background-image") !== -1 ? " men-quickadd-swatch-img" : "") +
            (on ? " is-active" : "") +
            (un ? " is-unavailable" : "") + '" style="' + escapeHtml(style) + '"' + attrs +
            ' title="' + escapeHtml(accessibleName) + '" aria-label="' +
            escapeHtml(accessibleName) + '"></button>';
        }
        return '<button type="button" class="men-quickadd-chip' + (on ? " is-active" : "") +
          (un ? " is-unavailable" : "") + '"' + attrs + ">" +
          escapeHtml(sizeSwitch ? qvSizeLabel(val.name) : val.name) + "</button>";
      }).join("");

      // [data-size-guide] on the card's size chips comes from
      // snippets/size-guide-type.liquid — bags, belts and one-size items
      // have a Size option but no guide on their PDP.
      var sizeGuideLink = opt.is_size && card.querySelector("[data-size][data-size-guide]")
        ?'<a class="men-quickadd-sizechart" href="' + href + '#size-guide">' +
            '<svg width="18" height="14" viewBox="0 0 24 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="3" width="22" height="10" rx="1"/><path d="M5 3v3M9 3v5M13 3v3M17 3v5M21 3v3"/></svg>' +
            escapeHtml(productText.size_guide || "Size guide") + "</a>"
        : "";

      var systemNow = sizeSwitch ? qvSizeSystemCurrent() : "";
      var systemRow = sizeSwitch
        ? '<div class="size-system men-quickadd-sizesystem" role="group" aria-label="' +
            escapeHtml(productText.size_system || "Size system") + '">' +
            ["eu", "us", "uk"].map(function (s) {
              var on = s === systemNow;
              return '<button type="button" class="size-system__btn' + (on ? " is-active" : "") +
                '" data-qv-size-system="' + s + '" data-text="' + s.toUpperCase() +
                '" aria-pressed="' + (on ? "true" : "false") + '">' + s.toUpperCase() + "</button>";
            }).join("") +
          "</div>"
        : "";
      // Imported machine names ("size_item") read as the storefront's own
      // label, the same rule as snippets/product-option-label.liquid.
      var optLabel = opt.name;
      if (String(opt.name).indexOf("_") !== -1) {
        optLabel = opt.is_size ? (productText.size || "Size") : opt.is_color ? (productText.colour || "Colour") : String(opt.name).replace(/_/g, " ");
      }
      return '<div class="men-quickadd-section">' +
        '<div class="men-quickadd-sizehead">' +
          '<span class="men-quickadd-label">' + escapeHtml(optLabel) + ":<b>" +
            escapeHtml(chosen ? (sizeSwitch ? qvSizeLabel(chosen) : chosen) : "—") + "</b></span>" +
          sizeGuideLink +
        "</div>" + systemRow +
        '<div class="' + (opt.is_color ? "men-quickadd-swatches" : "men-quickadd-chips") + '">' +
        values + "</div></div>";
    }).join("");

    var wishBtn = card.querySelector("[data-wish-btn]");
    var wished = !!(wishBtn && wishBtn.classList.contains("is-active"));

    var panel = '<div class="men-quickadd-panel">' +
      '<div class="men-quickadd-titlewrap">' +
        '<span class="men-quickadd-brand">' + escapeHtml(brandEl ? brandEl.textContent.trim() : "") + "</span>" +
        '<h3 class="men-quickadd-name" id="menQuickaddName">' + name + "</h3>" +
      "</div>" +
      '<div class="men-quickadd-pricewrap">' +
        '<div class="men-quickadd-price">' + priceHTML + "</div>" +
        paylaterLine + loyaltyLine +
        '<hr class="bs-rule-gold men-quickadd-rule">' +
      "</div>" +
      optionsHTML + qvLowStockHTML(variant) +
      // Refused-add message shows here, directly above the Add to bag button.
      // Rebuilt hidden by every qvRender(), so changing a selection clears it.
      '<p class="men-quickadd-oos" id="menQuickaddOos" role="alert" hidden></p>' +
      '<div class="men-quickadd-actions">' +
        '<button type="button" class="men-quickadd-cta" id="menQuickaddAdd"' +
          (!variant || !variant.available ? " disabled" : "") + '>' +
          (!variant || !variant.available ? "Sold Out" :
            '<svg class="men-quickadd-plus" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>Add to bag') +
        "</button>" +
        '<button type="button" class="men-quickadd-wish' + (wished ? " is-active" : "") + '" id="menQuickaddWish" ' +
          'aria-label="' + (wished ? "Remove from wishlist" : "Add to wishlist") + '" ' +
          'aria-pressed="' + (wished ? "true" : "false") + '">' + QV_HEART + "</button>" +
      "</div>" +
      '<a class="men-quickadd-fulldetails" href="' + href + '">Full details</a>' +
    "</div>";

    body.innerHTML = gallery + panel;
  }

  // Products with no size to choose skip the Quick View drawer entirely —
  // there's nothing to pick, so "Add to Bag" adds the current colour
  // selection straight away (see the button label in product-card.liquid).
  function quickAddDirect(card) {
    if (!card) return;
    var variants = getVariants(card);
    if (!variants.length) return;
    var activeSwatch = card.querySelector("[data-swatch].is-active");
    var color = activeSwatch ? activeSwatch.dataset.value : null;
    var variant = findVariant(variants, color, null) || variants[0];
    if (!variant || !variant.available) return;
    addToCart(variant.id, null, function (msg) { showCardOos(card, msg); });
  }

  function openQuickView(card) {
    var scrim = byId("menQuickaddScrim");
    var drawer = byId("menQuickaddDrawer");
    if (!card || !scrim || !drawer) return;
    var variants = getVariants(card);
    if (!variants.length) return;

    qvCard = card;
    qvVariants = variants;
    qvOptions = getCardOptions(card, variants);
    qvSelected = {};
    qvSizeSystem = null;
    qvSetupSizeSystem(card);

    // Carry over whatever the card already shows selected — only colour
    // and size exist there, the rest of the options have no tile UI.
    var activeSwatch = card.querySelector("[data-swatch].is-active");
    var activeSize = card.querySelector("[data-size].is-active");
    var colorPos = qvColorPos();
    var sizePos = qvSizePos();
    if (colorPos && activeSwatch) qvSelected[colorPos] = activeSwatch.dataset.value;
    if (sizePos && activeSize) qvSelected[sizePos] = activeSize.dataset.value;

    // Then fill every remaining option from the variant those picks
    // already resolve to. The card never marks a size chip active, so the
    // drawer used to open with nothing picked and demand a manual choice
    // even when an in-stock one was right there; the same reasoning
    // applies to a Width the tile can't show at all. Available-and-
    // cheapest wins, per findVariantByOptions.
    var seed = findVariantByOptions(variants, qvSelected, qvPositions());

    // The card's own active colour is just "whichever swatch renders
    // first" — easy for it to be entirely sold out (every size) even
    // though the product has stock under a different colour. Opening the
    // drawer pre-loaded onto a guaranteed Sold Out combination when an
    // available one is one click away is confusing, so if that's the
    // case, drop the card's picks and seed from the best available
    // variant across the WHOLE product instead — same rule, just with no
    // constraint. Only keep the card's own combination if the product
    // truly has no stock anywhere.
    if (!seed || !seed.available) {
      var availableSeed = findVariantByOptions(variants, {}, qvPositions());
      if (availableSeed && availableSeed.available) {
        seed = availableSeed;
        qvSelected = {};
      }
    }

    if (seed) {
      qvOptions.forEach(function (opt) {
        if (!qvSelected[opt.position]) {
          var value = (seed.options || [])[opt.position - 1];
          if (value) qvSelected[opt.position] = value;
        }
      });
    }

    qvRender();
    drawer.hidden = false;
    scrim.hidden = false;
    void drawer.offsetWidth; // commit the hidden state so both animate in
    drawer.classList.add("is-open");
    scrim.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeQuickView() {
    var scrim = byId("menQuickaddScrim");
    var drawer = byId("menQuickaddDrawer");
    if (!scrim || !drawer || drawer.hidden) return;
    drawer.classList.remove("is-open");
    scrim.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    // Keep the page locked until the panel has slid fully off-screen (matches
    // the 0.42s CSS transition), so its off-canvas position never flashes a
    // horizontal scrollbar mid-close.
    setTimeout(function () {
      drawer.hidden = true;
      scrim.hidden = true;
      document.body.style.overflow = "";
      qvCard = null;
    }, 440);
  }

  // Brief outline pulse on the option still waiting on a choice — mirrors
  // promptSizeSelection's on-card nudge when "Add to Cart" is pressed
  // early. Targets that option's own group, not just the size chips, so a
  // missing Width points at the Width row.
  function promptQvOptionSelection(pos) {
    var sections = document.querySelectorAll("#menQuickaddBody .men-quickadd-section");
    var index = qvOptions.map(function (o) { return o.position; }).indexOf(pos);
    var section = sections[index];
    var group = section && section.querySelector(".men-quickadd-chips, .men-quickadd-swatches");
    if (!group) return;
    group.style.outline = "2px solid var(--color-primary)";
    group.style.outlineOffset = "3px";
    setTimeout(function () {
      group.style.outline = "";
      group.style.outlineOffset = "";
    }, 1200);
  }

  // First option with nothing chosen, or 0 once everything is picked.
  function qvMissingOption() {
    for (var i = 0; i < qvOptions.length; i++) {
      if (!qvSelected[qvOptions[i].position]) return qvOptions[i].position;
    }
    return 0;
  }

  function onQuickViewBodyClick(e) {
    if (!qvCard) return;
    var el;

    if ((el = e.target.closest("[data-qv-size-system]"))) {
      try { window.localStorage.setItem("sizeSystem", el.dataset.qvSizeSystem); } catch (err) {}
      qvRender();
      return;
    }

    // One handler for every option value, whichever option it belongs to.
    if ((el = e.target.closest("[data-qv-opt]"))) {
      var qPos = parseInt(el.dataset.qvOpt, 10);
      var qVal = el.dataset.qvValue;

      // Two very different meanings of "crossed out", which this used to
      // treat as one and refuse alike:
      //   - no stock in ANY combination: genuinely sold out, nothing to
      //     select, so say so in the banner a refused add uses;
      //   - no stock ALONGSIDE THE CURRENT PICKS: the colour is fine, it
      //     simply isn't stocked in the size showing right now.
      // The second was being refused with "is out of stock, please choose
      // another" — wrong, and it walled off real stock: a colour carrying
      // the only in-stock size on the product could not be reached from the
      // drawer at all, while the PDP reached it in one click. Selectable now,
      // with the re-seed below moving the other positions onto something
      // buyable, exactly as the PDP does.
      var reachable = window.BSVariants.valueAvailable(
        qvVariants, qvPositions(), {}, qPos, qVal
      );
      if (!reachable) {
        var soldOutOpt = qvOptions.filter(function (o) {
          return String(o.position) === String(qPos);
        })[0];
        showQvOos(
          (qVal || "") +
          (soldOutOpt ? " (" + soldOutOpt.name + ")" : "") +
          " is out of stock. Please choose another."
        );
        return;
      }

      qvSelected[qPos] = qVal;

      // Whatever is picked at the other position(s) may not combine with this
      // value into a variant worth landing on. Two distinct failures, and only
      // the first used to be handled:
      //   - no such variant exists at all (a colour that only comes in one
      //     size), which this guard was written for;
      //   - the variant exists but is SOLD OUT, which it was not. Switching
      //     colour kept the previous size, so picking a colour whose stock
      //     sits in a different size landed on Sold Out at full price with
      //     the in-stock size one click away and nothing pointing at it.
      //     Testing whether a variant EXISTS rather than whether it can be
      //     BOUGHT is what let that through.
      // Re-seed the other positions from whichever variant this value really
      // resolves to (available + cheapest). The clicked value itself is never
      // moved: the shopper asked for it, so a colour that is genuinely sold
      // out in every size still lands on it and says so.
      var current = findVariantByOptions(qvVariants, qvSelected, qvPositions());
      if (!current || !current.available) {
        var seedSelection = {};
        seedSelection[qPos] = qVal;
        var seed = findVariantByOptions(qvVariants, seedSelection, qvPositions());
        // Adopt a buyable combination; or any real one when the current
        // picks resolve to nothing at all, so the picker is never left empty.
        if (seed && (seed.available || !current)) {
          qvPositions().forEach(function (p) {
            if (p !== qPos) qvSelected[p] = (seed.options || [])[p - 1];
          });
        }
      }

      var colorPos = qvColorPos();
      var sizePos = qvSizePos();
      // The card tile only understands colour and size; anything else the
      // drawer offers has nowhere to show on it.
      syncCardSelection(
        qvCard,
        colorPos ? qvSelected[colorPos] : null,
        sizePos ? qvSelected[sizePos] : null
      );
      qvRender();
      return;
    }

    if (e.target.closest("#menQuickaddWish")) {
      var wishBtn = qvCard.querySelector("[data-wish-btn]");
      if (wishBtn) toggleWishlist(wishBtn);
      qvRender();
      return;
    }

    if (e.target.closest("#menQuickaddAdd")) {
      // Every option the drawer offers gates the add, not just size — an
      // unpicked Width is as unorderable as an unpicked size.
      var missing = qvMissingOption();
      if (missing) {
        promptQvOptionSelection(missing);
        return;
      }
      var variant = qvActiveVariant();
      if (!variant || !variant.available) return;
      addToCart(variant.id, closeQuickView, showQvOos);
    }
  }

  // Fills the in-flow banner under the Quick View's Add to bag button on a
  // refused add. The drawer stays open (addToCart doesn't run onSuccess), so
  // the shopper sees why and can pick another size without a floating toast.
  function showQvOos(message) {
    var el = byId("menQuickaddOos");
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  /* Places sort and the category pills for the current viewport. On mobile,
     sort moves into .plp-toolbar-left (its .plp-tools-right home is
     display:none there) while the category pills stay put in
     .plp-subcats-bar below the collection description — the same place they
     sit on desktop — rather than sharing the toolbar row. Desktop keeps sort
     in .plp-tools-right and adds the scroll-triggered pill move (see
     initStickyToolbar). Also run on resize (see watchCardLayoutResize) so
     crossing the breakpoint without a reload relocates everything correctly. */
  function syncQuickfiltersForViewport() {
    var subcatsBar = byId("plpSubcatsBar");
    var quickFilters = byId("plpQuickFilters");
    var toolbar = byId("plpToolbar");
    var toolbarLeft = toolbar ? toolbar.querySelector(".plp-toolbar-left") : null;
    var toolsRight = toolbar ? toolbar.querySelector(".plp-tools-right") : null;
    var sortWrap = byId("plpSort");
    if (!toolbarLeft) return;
    // The category pills (quickFilters/subcatsBar) are optional — a collection
    // with no sub-categories renders neither. Sort relocation must NOT be gated
    // behind them: on mobile .plp-tools-right is display:none, so a sort left
    // there is invisible/unusable. Move sort on its own; only touch the pills
    // when they actually exist.
    var hasPills = quickFilters && subcatsBar;
    if (window.matchMedia(CARD_MOBILE_QUERY).matches) {
      if (sortWrap && sortWrap.parentElement !== toolbarLeft) {
        toolbarLeft.appendChild(sortWrap);
      }
      // Pills sit below the description by default; the sticky observer moves
      // them into the toolbar while stuck (same as desktop), so only reset
      // them into the subcats bar here when the toolbar isn't stuck.
      if (hasPills && !toolbar.classList.contains("is-stuck") && quickFilters.parentElement !== subcatsBar) {
        subcatsBar.appendChild(quickFilters);
        subcatsBar.hidden = false;
      }
    } else {
      if (sortWrap && toolsRight && sortWrap.parentElement !== toolsRight) {
        toolsRight.appendChild(sortWrap);
      }
      if (hasPills && !toolbar.classList.contains("is-stuck") && quickFilters.parentElement !== subcatsBar) {
        subcatsBar.appendChild(quickFilters);
        subcatsBar.hidden = false;
      }
    }
    // Reparenting changes quickFilters' available width without firing a
    // resize event — recheck the arrows' disabled/overflow state directly.
    // It also resets the row's scrollLeft to 0, so the selected pill has to
    // be put back at the reading-start edge (alignActiveQuickfilter only
    // acts when the row really was reset, so this cannot fight the shopper).
    if (hasPills) {
      updateQuickfilterArrows(quickFilters);
      alignActiveQuickfilter(quickFilters);
    }
  }

  /* ── Category quick-filter pills: every way a user might try to slide it ──
     .plp-quickfilters already scrolls via touch swipe and a trackpad's
     horizontal gesture (overflow-x:auto + -webkit-overflow-scrolling:touch),
     but neither a plain mouse click-drag nor a plain vertical mouse-wheel
     roll does anything — the browser has no native "drag to scroll" for a
     mouse, and a bare wheel roll over the row scrolls the PAGE, not the row,
     since the row's only overflow axis is horizontal. Add both by hand.
     Bound once directly to #plpQuickFilters (not rebuilt — only its
     innerHTML is, by renderItemTypePills — and reparented, not recreated, by
     the sticky-toolbar relocation), so this survives both. */
  function initQuickfilterDrag() {
    var el = byId("plpQuickFilters");
    if (!el || el.dataset.dragBound) return;
    el.dataset.dragBound = "true";

    var isDown = false;
    var dragged = false;
    var startX = 0;
    var startScroll = 0;

    el.addEventListener("mousedown", function (e) {
      isDown = true;
      dragged = false;
      startX = e.pageX;
      startScroll = el.scrollLeft;
      el.classList.add("is-dragging");
    });

    window.addEventListener("mousemove", function (e) {
      if (!isDown) return;
      var delta = e.pageX - startX;
      if (Math.abs(delta) > 4) dragged = true;
      // Physical drag - correct as-is in both directions (see blue-salon.js)
      el.scrollLeft = startScroll - delta;
    });

    window.addEventListener("mouseup", function () {
      if (!isDown) return;
      isDown = false;
      el.classList.remove("is-dragging");
    });

    // A drag that actually moved the row shouldn't also fire whichever
    // pill's click landed under the pointer on release (that would toggle
    // a filter the shopper never meant to pick) — swallow just that one
    // click. Capture phase so this runs before onRootClick's delegated
    // pill handler sees the same event.
    el.addEventListener("click", function (e) {
      if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; }
    }, true);

    // Plain mouse-wheel roll — deltaX already carries a trackpad's own
    // horizontal swipe (left as native), so only step in for a vertical
    // roll, and only when there's actually somewhere to scroll to.
    el.addEventListener("wheel", function (e) {
      if (el.scrollWidth <= el.clientWidth) return;
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      // Pinned in the sticky toolbar, the row sits under the pointer most of
      // the time a shopper scrolls the page, and taking the wheel there froze
      // the page scroll - the page wins while stuck (the arrows, drag and a
      // trackpad swipe still move the row).
      var bar = el.closest(".plp-toolbar");
      if (bar && bar.classList.contains("is-stuck")) return;
      // At the end of the row in the wheel's direction, hand the wheel back
      // to the page instead of swallowing it.
      var pos = BS.rtl.pos(el);
      if ((e.deltaY > 0 && pos >= BS.rtl.max(el) - 1) || (e.deltaY < 0 && pos <= 1)) return;
      e.preventDefault();
      // a vertical wheel roll advances the rail along the reading order
      BS.rtl.by(el, e.deltaY * 1.5);
    }, { passive: false });
  }

  /* ── Sticky toolbar: moves the sub-category tabs in/out ──── */
  function initStickyToolbar() {
    var sentinel = byId("plpToolbarSentinel");
    var toolbar = byId("plpToolbar");
    var subcatsBar = byId("plpSubcatsBar");
    var quickFilters = byId("plpQuickFilters");
    var toolbarLeft = toolbar ? toolbar.querySelector(".plp-toolbar-left") : null;
    if (!sentinel || !toolbar || !("IntersectionObserver" in window)) return;

    syncQuickfiltersForViewport();

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        var stuck = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        toolbar.classList.toggle("is-stuck", stuck);
        if (!stuck) toolbar.classList.remove("is-hidden");

        // The sub-category pills sit below the description by default and slide
        // into the sticky toolbar once it sticks, at every breakpoint — so the
        // category nav stays reachable while scrolling on mobile too.
        if (quickFilters && subcatsBar && toolbarLeft) {
          if (stuck && quickFilters.parentElement !== toolbarLeft) {
            toolbarLeft.appendChild(quickFilters);
            subcatsBar.hidden = true;
          } else if (!stuck && quickFilters.parentElement !== subcatsBar) {
            subcatsBar.appendChild(quickFilters);
            subcatsBar.hidden = false;
          }
          updateQuickfilterArrows(quickFilters);
          pinQuickfilters(quickFilters);
          // Moving the row between containers wipes its scroll position;
          // restore the selected pill to the start edge. See the same pair
          // in syncQuickfiltersForViewport.
          alignActiveQuickfilter(quickFilters);
        }
      },
      { threshold: 0 }
    );
    observer.observe(sentinel);

    // Once stuck, only show the toolbar while scrolling down — scrolling
    // up slides it out of view so it doesn't sit fixed over the grid.
    var lastY = window.scrollY;
    var scrollDirection = "down";
    var ticking = false;
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        // Trackpad/momentum scrolling constantly produces 1px reversals
        // mid-gesture — comparing every frame to the last flips the
        // direction back and forth fast enough to hide the toolbar almost
        // as soon as it appears, even while the shopper is clearly
        // scrolling down. Only trust a direction once it's moved a few px
        // (same fix as #navZone's reveal in blue-salon.js).
        if (Math.abs(y - lastY) > 5) {
          scrollDirection = y < lastY ? "up" : "down";
          lastY = y;
        }
        if (toolbar.classList.contains("is-stuck")) {
          toolbar.classList.toggle("is-hidden", scrollDirection === "up");
        }
        ticking = false;
      });
    });
  }

  /* ── Grid density (client-side only) ─────────────────────── */
  function setDensity(cols) {
    // On the USF-integrated collection page there's no #plpGrid — USF mounts
    // its own grid (class .plp-grid only) inside #usf_container, and Vue
    // re-renders it from window._usfGridWrapStyle on every filter/sort change,
    // which would otherwise revert a manually-set --plp-cols. Update both.
    var grid = byId("plpGrid") || document.querySelector("#usf_container .plp-grid");
    if (grid) grid.style.setProperty("--plp-cols", cols);
    window._usfGridWrapStyle = "--plp-cols: " + cols + ";";
    document.querySelectorAll(".plp-density button").forEach(function (b) {
      b.classList.toggle("is-active", b.dataset.cols === cols);
    });
    try {
      localStorage.setItem("bs_plp_density", cols);
    } catch (e) {}

    // A different column count wants a different page size to end on a full
    // row — 28 products at 4 per row, 27 at 3 (snippets/plp-page-size). It
    // re-queries USF only when the number actually changes, so the restore-
    // on-load call below and a toggle back to the same density cost nothing.
    if (window.bsPlpFillRows) window.bsPlpFillRows.update();
  }

  function restoreDensity() {
    try {
      var saved = localStorage.getItem("bs_plp_density");
      if (saved) setDensity(saved);
    } catch (e) {}
  }

  /* ── Filter drawer (mobile off-canvas + desktop "show filters") ── */
  function openFilterDrawer() {
    var filters = byId("plpFilters");
    var scrim = byId("plpFiltersScrim");
    if (!filters) return;
    filters.classList.add("is-drawer-mode");
    if (scrim) scrim.hidden = false;
    requestAnimationFrame(function () {
      filters.classList.add("is-drawer-open");
      if (scrim) scrim.classList.add("is-open");
    });
    document.body.style.overflow = "hidden";
  }

  function closeFilterDrawer() {
    var filters = byId("plpFilters");
    var scrim = byId("plpFiltersScrim");
    if (!filters || !filters.classList.contains("is-drawer-open")) return;
    filters.classList.remove("is-drawer-open");
    if (scrim) scrim.classList.remove("is-open");
    document.body.style.overflow = "";
    setTimeout(function () {
      filters.classList.remove("is-drawer-mode");
      if (scrim) scrim.hidden = true;
    }, 320);
  }

  /* ── Facet accordions ────────────────────────────────────── */
  function toggleFacet(btn) {
    var facet = btn.closest(".plp-facet");
    if (!facet) return;
    var isOpen = facet.classList.toggle("is-open");
    btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
  }

  /* ── Sort dropdown (progressive enhancement over a real <select>) ──
     On mobile this opens as a bottom sheet (see .plp-sort-menu's ≤760px
     CSS) sharing the filter drawer's scrim + body-scroll lock — same
     rAF-then-class pattern as openFilterDrawer/closeFilterDrawer, so the
     slide-up/down transform has a starting frame to animate from instead
     of jumping straight from display:none to open (or vice versa).

     While open on mobile, the menu is also reparented onto <body>: it
     normally lives inside .plp-toolbar, but .plp-toolbar has its own
     `transform` (used for its sticky show/hide slide), and ANY transform
     makes an element the containing block for position:fixed
     descendants — so the sheet would anchor to .plp-toolbar's small box
     instead of the viewport. Moved back afterward so desktop's anchored
     dropdown (position:absolute off .plp-sort) still works normally. */
  function toggleSortMenu() {
    var wrap = byId("plpSort");
    var menu = byId("plpSortMenu");
    var btn = byId("plpSortBtn");
    if (!wrap || !menu || !btn) return;
    if (!menu.hidden) {
      closeSortMenu();
      return;
    }
    var scrim = byId("plpFiltersScrim");
    var isMobile = window.matchMedia(CARD_MOBILE_QUERY).matches;
    if (isMobile) document.body.appendChild(menu);
    menu.hidden = false;
    btn.setAttribute("aria-expanded", "true");
    if (isMobile) {
      if (scrim) scrim.hidden = false;
      document.body.style.overflow = "hidden";
    }
    requestAnimationFrame(function () {
      wrap.classList.add("is-open");
      menu.classList.add("is-open");
      if (isMobile && scrim) scrim.classList.add("is-open");
    });
  }

  function closeSortMenu() {
    var wrap = byId("plpSort");
    var menu = byId("plpSortMenu");
    var btn = byId("plpSortBtn");
    var scrim = byId("plpFiltersScrim");
    var filters = byId("plpFilters");
    if (!wrap || !menu || !wrap.classList.contains("is-open")) return;
    var filtersOpen = !!(filters && filters.classList.contains("is-drawer-open"));
    wrap.classList.remove("is-open");
    menu.classList.remove("is-open");
    if (btn) btn.setAttribute("aria-expanded", "false");
    if (scrim && !filtersOpen) scrim.classList.remove("is-open");
    if (!filtersOpen) document.body.style.overflow = "";
    setTimeout(function () {
      menu.hidden = true;
      if (scrim && !filtersOpen) scrim.hidden = true;
      if (menu.parentElement !== wrap) wrap.appendChild(menu);
    }, 320);
  }

  function selectSortOption(li) {
    var value = li.dataset.value;
    var valueEl = byId("plpSortValue");
    if (valueEl) valueEl.textContent = li.textContent;
    Array.prototype.forEach.call(li.parentElement.children, function (item) {
      var active = item === li;
      item.classList.toggle("is-active", active);
      item.setAttribute("aria-selected", active ? "true" : "false");
    });
    closeSortMenu();

    var select = byId("plpSortSelect");
    if (select) {
      select.value = value;
      triggerFormRefresh();
      return;
    }

    // USF-integrated page: there's no native <select>/form to submit — USF
    // owns product fetching, so drive its sort state directly instead.
    if (window.usf && usf.queryRewriter) usf.queryRewriter.sort = value;
  }

  // Rebuild the dropdown's option list from USF's own configured sort fields
  // (usf.settings.search.sortFields + its translation dictionary) instead of
  // the server-rendered Shopify collection.sort_options list. USF's fields
  // aren't the same set — e.g. "Relevance" and "Discount: High to Low" have
  // no Shopify sort_by equivalent — so collection.sort_options can only ever
  // be an approximate placeholder for the USF page; this replaces it with
  // the real thing once usf.settings is available. No-op on the no-usf
  // page, where #plpSortSelect already carries the real, correct list.
  function renderUsfSortMenu() {
    if (byId("plpSortSelect")) return;
    var menu = byId("plpSortMenu");
    var valueEl = byId("plpSortValue");
    if (!menu || !valueEl) return;
    if (!window.usf || !usf.settings || !usf.settings.search) return;
    var fields = usf.settings.search.sortFields;
    if (!fields || !fields.length) return;
    var loc = usf.settings.translation || {};
    var current = new URLSearchParams(window.location.search).get("usf_sort") || fields[0];

    menu.innerHTML = "";
    fields.forEach(function (value) {
      var active = value === current;
      // Our locale map wins when it has the value; otherwise fall back to
      // USF's own dictionary. `value` itself is never translated - it is what
      // drives usf.queryRewriter.sort in selectSortOption.
      var label = bsLabel(value, "sort_map", loc["sortBy_" + value] || value);
      var li = document.createElement("li");
      li.className = "plp-sort-opt" + (active ? " is-active" : "");
      li.setAttribute("role", "option");
      li.setAttribute("aria-selected", active ? "true" : "false");
      li.dataset.value = value;
      li.textContent = label;
      menu.appendChild(li);
      if (active) valueEl.textContent = label;
    });
  }

  // The "N items" count next to the collection title is server-rendered
  // from collection.products_count once, but USF's own filtering/search
  // narrows the actual result set client-side — so it goes stale as soon
  // as a filter is applied. USF already renders the live total in its own
  // "N products" summary (usf-sr-summary, near the toolbar); read the
  // number back out of that rather than re-deriving it, since it's the
  // one thing guaranteed to already be in sync with the current results.
  function syncPlpCountFromUsf() {
    var countEl = byId("plpCount");
    var summaryEl = document.querySelector("#usf_container .usf-sr-summary");
    if (!countEl || !summaryEl) return;
    var match = summaryEl.textContent.match(/[\d,]+/);
    if (!match) return;
    countEl.textContent = match[0] + " " + ((window.BS_I18N || {}).items || "items");
  }

  function syncSortUI(doc) {
    var nextSelect = doc.getElementById("plpSortSelect");
    var curSelect = byId("plpSortSelect");
    if (nextSelect && curSelect) curSelect.innerHTML = nextSelect.innerHTML;
    var menu = byId("plpSortMenu");
    if (menu && curSelect) {
      var selectedOption = curSelect.options[curSelect.selectedIndex];
      Array.prototype.forEach.call(menu.children, function (li) {
        var active = li.dataset.value === curSelect.value;
        li.classList.toggle("is-active", active);
        li.setAttribute("aria-selected", active ? "true" : "false");
      });
      var valueEl = byId("plpSortValue");
      if (valueEl && selectedOption) valueEl.textContent = selectedOption.textContent;
    }
  }

  /* ── Facets/sort refresh: fetch the section, swap in place ── */
  function swapInnerById(doc, id) {
    var next = doc.getElementById(id);
    var current = byId(id);
    if (next && current) current.innerHTML = next.innerHTML;
  }

  function swapOuterById(doc, id) {
    var next = doc.getElementById(id);
    var current = byId(id);
    if (next && current) current.outerHTML = next.outerHTML;
  }

  function swapTextById(doc, id) {
    var next = doc.getElementById(id);
    var current = byId(id);
    if (next && current) current.textContent = next.textContent;
  }

  function refreshResults(url, options) {
    options = options || {};
    var pushState = options.pushState !== false;
    var root = byId("plpRoot");
    if (!root) return;
    root.classList.add("is-loading");

    var sep = url.indexOf("?") === -1 ? "?" : "&";
    fetch(url + sep + "section_id=main", { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) {
        if (!r.ok) throw new Error("Bad response");
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        swapInnerById(doc, "plpFilters");
        swapInnerById(doc, "plpGrid");
        swapOuterById(doc, "plpLoadMore");
        swapOuterById(doc, "plpFilterBadge");
        swapTextById(doc, "plpCount");
        swapTextById(doc, "plpTitleTerm");
        syncSortUI(doc);

        // The swapped-in grid is freshly rendered in raw (desktop) DOM order and
        // needs the same on-load enhancers the initial page applies, or a
        // filter/sort refresh leaves cards mis-laid-out on mobile (see the same
        // pass in loadNextPage below). All four are idempotent.
        var refreshedGrid = byId("plpGrid");
        if (refreshedGrid) {
          stripBrandPrefixes(refreshedGrid);
          tagQuickaddState(refreshedGrid);
          layoutCardInfo(refreshedGrid);
          renderSwatchThumbnails(refreshedGrid);
          markSwatchAvailability(refreshedGrid);
          // The in-grid media tile is part of the swapped-in markup, so its
          // video arrives unwired (and paused at preload="none") like a fresh
          // page load's does.
          refreshedGrid.querySelectorAll("[data-plp-grid-media]").forEach(initGridMediaVideo);
        }

        hydrateWishlist();
        refreshLoadMoreObserver();
        if (pushState) history.pushState({ plp: true }, "", url || location.pathname);
        lastRenderedHref = window.location.href;
      })
      .catch(function () {
        window.location.href = url;
      })
      .finally(function () {
        root.classList.remove("is-loading");
      });
  }

  function triggerFormRefresh() {
    var form = byId("plpFiltersForm");
    if (!form) return;
    var params = new URLSearchParams(new FormData(form));
    var url = form.getAttribute("action") + "?" + params.toString();
    refreshResults(url);
  }

  /* ── Infinite scroll ──────────────────────────────────────── */
  function refreshLoadMoreObserver() {
    var sentinel = byId("plpLoadMore");
    if (loadMoreObserver) loadMoreObserver.disconnect();
    if (!sentinel || sentinel.hidden || !("IntersectionObserver" in window)) return;
    loadMoreObserver = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) loadNextPage();
      },
      { rootMargin: "600px 0px" }
    );
    loadMoreObserver.observe(sentinel);
  }

  function loadNextPage() {
    var sentinel = byId("plpLoadMore");
    if (!sentinel || isLoadingMore) return;
    var nextUrl = sentinel.dataset.nextUrl;
    if (!nextUrl) return;
    isLoadingMore = true;

    var sep = nextUrl.indexOf("?") === -1 ? "?" : "&";
    fetch(nextUrl + sep + "section_id=main")
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var nextGrid = doc.getElementById("plpGrid");
        var curGrid = byId("plpGrid");
        if (nextGrid && curGrid) {
          var children = Array.prototype.slice.call(nextGrid.children);
          children.forEach(function (child) { curGrid.appendChild(child); });
        }

        var nextSentinel = doc.getElementById("plpLoadMore");
        if (nextSentinel) {
          sentinel.dataset.nextUrl = nextSentinel.dataset.nextUrl || "";
          sentinel.hidden = nextSentinel.hidden;
        } else {
          sentinel.hidden = true;
        }

        // Newly appended cards render in their raw (desktop) DOM order and
        // haven't been through the on-load enhancers — without this, paginated
        // cards look different from the first page (price/quick-add misplaced on
        // mobile, unstyled swatches, un-stripped brand prefixes). Re-run the
        // same passes the initial load applies, scoped to the grid; all four are
        // idempotent so re-processing already-styled cards is harmless.
        if (curGrid) {
          stripBrandPrefixes(curGrid);
          tagQuickaddState(curGrid);
          layoutCardInfo(curGrid);
          renderSwatchThumbnails(curGrid);
          markSwatchAvailability(curGrid);
        }

        hydrateWishlist();
        refreshLoadMoreObserver();
      })
      .catch(function () {})
      .finally(function () {
        isLoadingMore = false;
      });
  }

  /* ── Delegated event handlers on #plpRoot ─────────────────── */
  function onRootClick(e) {
    var target = e.target;
    var el;

    // Back button in the crumb trail — mirrors the PDP's own back button
    // (assets/product.js): a short fade (body.plp-leaving, cleared on
    // pageshow below) before history.back(), so the tap reads as a
    // deliberate transition instead of an instant, jarring cut.
    if ((el = target.closest("[data-plp-back]"))) {
      e.preventDefault();
      var reduceMotion = window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      document.body.classList.add("plp-leaving");
      setTimeout(function () { history.back(); }, reduceMotion ? 0 : 160);
      return;
    }

    // Item Type quick-filter pills (USF-integrated page, built client-side by
    // renderItemTypePills): reassign USF's own facetFilters state — same
    // mechanism the real "Item Type" sidebar checkbox uses, same collection,
    // no navigation.
    if ((el = target.closest("[data-sale-pill]"))) {
      markRefreshing();
      selectPill(saleFilterOn() ? "all" : "sale");
      return;
    }
    if ((el = target.closest("[data-new-in-pill]"))) {
      markRefreshing();
      selectPill(newInFilterOn() ? "all" : "new");
      return;
    }
    if ((el = target.closest("[data-gender-value]"))) {
      applyGenderPill(el.classList.contains("is-active") ? null : el.dataset.genderValue);
      return;
    }
    if ((el = target.closest("[data-item-type-all]"))) {
      if (saleFilterOn() || newInFilterOn()) { markRefreshing(); selectPill("all"); }
      else if (!el.classList.contains("is-active")) { markRefreshing(); applyItemTypeFacet(null); }
      return;
    }
    if ((el = target.closest("[data-item-type-value]")) && (saleFilterOn() || newInFilterOn())) {
      markRefreshing();
      selectPill("item", el.dataset.itemTypeValue);
      return;
    }
    if ((el = target.closest("[data-item-type-value]")) && byId("plpQuickFilters") && byId("plpQuickFilters").querySelector(".plp-quickfilters-pinned")) markRefreshing();
    if ((el = target.closest("[data-item-type-value]"))) {
      applyItemTypeFacet(el.classList.contains("is-active") ? null : el.dataset.itemTypeValue);
      return;
    }
    // Item Type quick-filter pills (native collection.filters page): check
    // the matching sidebar checkbox and re-run the existing AJAX facet
    // refresh — same collection, no navigation.
    if ((el = target.closest("[data-native-item-type-all]"))) {
      if (!el.classList.contains("is-active")) applyNativeItemTypeFilter(null);
      return;
    }
    if ((el = target.closest("[data-item-type-param]"))) {
      applyNativeItemTypeFilter(el.classList.contains("is-active") ? null : el.dataset.itemTypeParam);
      return;
    }
    if ((el = target.closest("[data-usf-chip]"))) { removeUsfFacetValue(el.dataset.facetId, el.dataset.facetValue); return; }
    if ((el = target.closest("[data-usf-clear-all-chip]"))) { clearAllUsfFilters(); updateFilterBadgeFromUsf(); return; }
    if ((el = target.closest(".plp-density button"))) { setDensity(el.dataset.cols); return; }
    if ((el = target.closest("[data-facet-toggle]"))) { toggleFacet(el); return; }
    if ((el = target.closest("#plpSortBtn"))) { toggleSortMenu(); return; }
    // NB: .plp-sort-opt is intentionally NOT handled here — on mobile the sort
    // menu is reparented onto <body> (outside #plpRoot; see toggleSortMenu), so
    // its option clicks never reach this delegated handler. Handled on the
    // document-level listener instead, which sees the click in both layouts.
    if ((el = target.closest("#plpFilterCollapse, #plpFilterToggle"))) {
      // On mobile, USF never relocates its real facets into our drawer (see
      // assets/usf.js) — it renders its own native trigger instead
      // (#usf_container .usf-filters, bound to its internal onMobileToggle).
      // Forward the click there instead of opening our empty custom drawer.
      var usfMobileToggle = document.querySelector("#usf_container .usf-filters");
      if (usfMobileToggle && window.usf && usf.isMobile) {
        usfMobileToggle.click();
      } else {
        openFilterDrawer();
      }
      return;
    }
    if ((el = target.closest("#plpFilterHide, #plpFiltersClose, #plpFiltersScrim"))) { closeFilterDrawer(); return; }
    if ((el = target.closest("#plpClearFilters"))) { clearAllUsfFilters(); updateFilterBadgeFromUsf(); return; }
    if ((el = target.closest("[data-wish-btn]"))) { e.preventDefault(); toggleWishlist(el); return; }
    // Checked before the plain [data-swatch] case below — the "+N" button
    // carries both attributes (its own hidden colour, so the card's main
    // image updates like any other swatch, plus the "+N" affordance) and
    // needs both selectSwatch's image swap and openQuickView to run.
    if ((el = target.closest("[data-swatch-more]"))) {
      selectSwatch(el);
      openQuickView(el.closest("[data-product-card]"));
      return;
    }
    if ((el = target.closest("[data-swatch]")) && !el.disabled) { selectSwatch(el); return; }
    if ((el = target.closest("[data-size]")) && !el.disabled) { selectSize(el); return; }
    if ((el = target.closest("[data-dot]"))) { e.preventDefault(); selectDot(el); return; }
    if ((el = target.closest("[data-quick-add]")) && !el.disabled) {
      e.preventDefault();
      var quickAddCard = el.closest("[data-product-card]");
      if (!quickAddCard) return;
      // Open the drawer whenever anything is still left to choose, rather
      // than only when the tile happens to show a size row: colour is
      // pickable inline on the card, but a Size / Width / Volume option
      // isn't, and gating on [data-size] alone meant a product whose only
      // unpicked option was Width got added without ever being asked.
      var pending = getCardOptions(quickAddCard, getVariants(quickAddCard))
        .filter(function (o) { return !o.is_color; });
      if (pending.length) {
        openQuickView(quickAddCard);
      } else {
        quickAddDirect(quickAddCard);
      }
      return;
    }
  }

  function onRootChange(e) {
    var target = e.target;
    if (target.id === "plpSortSelect") {
      triggerFormRefresh();
      return;
    }
    if (target.closest("#plpFiltersForm") && (target.matches('input[type="checkbox"]') || target.matches('input[type="number"]'))) {
      triggerFormRefresh();
    }
  }

  function onRootSubmit(e) {
    if (e.target.id === "plpFiltersForm") {
      e.preventDefault();
      triggerFormRefresh();
    }
  }

  /* ── Quick View drawer handlers ───────────────────────────────
     The drawer (#menQuickaddDrawer) is a shared, page-level element rendered
     by every section that shows the PLP card. Bind its close/body handlers
     once, independent of #plpRoot, so a landing page with only a secondary
     grid can still close the Quick View it opens. */
  function bindQuickView() {
    var drawer = byId("menQuickaddDrawer");
    var qvScrim = byId("menQuickaddScrim");
    var qvCloseBtn = byId("menQuickaddClose");
    var qvBodyEl = byId("menQuickaddBody");
    // Guard on a DOM dataset (not a closure var): a page with several grid
    // sections injects listing.js more than once, so the flag has to be shared
    // across those separate IIFE runs — the same way #plpRoot's plpInit is.
    var marker = drawer || qvBodyEl || qvScrim || qvCloseBtn;
    if (!marker || marker.dataset.qvBound) return;
    marker.dataset.qvBound = "true";
    if (qvCloseBtn) qvCloseBtn.addEventListener("click", closeQuickView);
    if (qvScrim) qvScrim.addEventListener("click", closeQuickView);
    if (qvBodyEl) qvBodyEl.addEventListener("click", onQuickViewBodyClick);
  }

  /* ── Secondary product grids ───────────────────────────────────
     Landing sections reuse the PLP card but their grid isn't the single
     #plpRoot the PLP boot binds: spotlight-shop-grid uses its own id
     (#plpSpot), and — the common case — several product-grid / collection-
     banner-slider sections on one page each render id="plpRoot", so the page
     has DUPLICATE #plpRoot nodes and only the first was ever wired. Wire every
     grid except that single primary node here (compared by DOM identity, not
     id, so the duplicate #plpRoot nodes are caught) and process its cards, so
     Quick View / quick-add / swatches work on all of them instead of the
     unwired ones falling through the card link to the product page. Runs even
     when there's no #plpRoot at all. */
  function initSecondaryGrids() {
    var primary = byId("plpRoot"); // the one bound by the PLP boot below
    var bound = false;
    document.querySelectorAll(".plp-grid[data-cart-add-url]").forEach(function (grid) {
      if (grid === primary || grid.dataset.plpGridBound) return;
      grid.dataset.plpGridBound = "true";
      bound = true;
      grid.addEventListener("click", onRootClick);
      grid.addEventListener("change", onRootChange);
      grid.addEventListener("submit", onRootSubmit);
      stripBrandPrefixes(grid);
      tagQuickaddState(grid);
      layoutCardInfo(grid);
      syncMainImageToActiveSwatch(grid);
      renderSwatchThumbnails(grid);
      markSwatchAvailability(grid);
    });
    if (bound) hydrateWishlist();
    bindQuickView();
  }

  /* ── Boot ─────────────────────────────────────────────────── */
  function initAll() {
    // Wire any non-#plpRoot product grids first — this is what makes Quick
    // View work on landing sections, and it runs whether or not a PLP is here.
    // Isolated because it runs ahead of the plpInit flag and the watchers
    // below: a throw here used to abort the PLP's entire setup before it had
    // even started, leaving nothing observing the USF grid.
    try {
      initSecondaryGrids();
    } catch (err) {
      if (window.console && console.error) console.error("PLP init (secondary grids) failed:", err);
    }

    var root = byId("plpRoot");
    if (!root || root.dataset.plpInit) return;
    root.dataset.plpInit = "true";

    // Bind interactivity — and start up the USF facet watchers that drive
    // the Item Type pills — before any of the progressive-enhancement calls
    // below. This whole function is one synchronous run: an uncaught throw
    // partway through (an image/variants-JSON race in the swatch helpers has
    // been observed to do this intermittently on some page loads) would
    // otherwise abort everything after it, silently leaving the page with
    // no working clicks at all until a reload got luckier timing.
    root.addEventListener("click", onRootClick);
    root.addEventListener("change", onRootChange);
    root.addEventListener("submit", onRootSubmit);
    bindQuickView();
    watchUsfFilters();
    watchUsfMobileFacets();
    // Before USF's first search, so a ?sale=1 link lands already filtered.
    // usf.js arrives after this script, hence the short retry.
    if (byId("plpQuickFilters")) {
      (function waitForUsf(tries) {
        installSaleFilter();
        if (!(window.usf && usf.utils && usf.utils.send && usf.utils.send.__bsSale) && tries > 0) {
          setTimeout(function () { waitForUsf(tries - 1); }, 50);
        }
      })(200);
    }

    try {
      restoreDensity();
      hydrateWishlist();
      stripBrandPrefixes();
      tagQuickaddState();
      layoutCardInfo();
    } catch (err) {
      if (window.console && console.error) console.error("PLP init (progressive enhancements) failed:", err);
    }

    // Isolated from the rest of init: the image/variants-JSON race mentioned
    // above lives in these two calls specifically. Without its own
    // try/catch, a throw here used to also skip watchUsfGrid() below (never
    // wired up for the rest of the page's life), leaving every later USF
    // re-render with its unfixed, broken-CSS-colour swatches.
    try {
      syncMainImageToActiveSwatch();
      renderSwatchThumbnails();
    } catch (err) {
      if (window.console && console.error) console.error("PLP init (swatch thumbnails) failed:", err);
    }

    try {
      markSwatchAvailability();
      // Both PLP templates: places the clone on the USF grid if it's already
      // rendered, and wires the no-usf template's server-rendered tile (where
      // there's no USF re-render to hook, so this is the only pass it gets).
      injectGridMedia();
      document.querySelectorAll("[data-plp-grid-media]").forEach(initGridMediaVideo);
      equalizeCardHeights();
      watchCardLayoutResize();
      watchUsfGrid();
      initStickyToolbar();
      initQuickfilterDrag();
      initQuickfilterArrows();
      refreshLoadMoreObserver();

      var sortEl = byId("plpSort");
      var sortNative = byId("plpSortNative");
      if (sortEl) sortEl.hidden = false;
      if (sortNative) sortNative.hidden = true;
      renderUsfSortMenu();
      syncPlpCountFromUsf();
      updateFilterBadgeFromUsf();
      renderMobileFilterChips();
    } catch (err) {
      if (window.console && console.error) console.error("PLP init (progressive enhancements) failed:", err);
    }
  }

  document.addEventListener("click", function (e) {
    // Sort-option selection lives here (not in onRootClick) so it still fires
    // when the menu is reparented onto <body> on mobile — the click bubbles to
    // document in both the desktop (menu in #plpRoot) and mobile layouts.
    var opt = e.target.closest(".plp-sort-opt");
    if (opt) { selectSortOption(opt); return; }
    var sortWrap = byId("plpSort");
    if (sortWrap && sortWrap.classList.contains("is-open") && !sortWrap.contains(e.target)) {
      closeSortMenu();
    }
  });

  document.addEventListener("change", function (e) {
    var jump = e.target.closest("[data-pagination-jump]");
    if (!jump) return;
    var page = parseInt(jump.value, 10);
    if (!(page > 0)) return;
    var target = new URL(window.location.href);
    target.searchParams.set("page", page);
    window.location.assign(target.toString());
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeSortMenu();
      closeFilterDrawer();
      closeQuickView();
    }
  });

  window.addEventListener("popstate", function () {
    // A bfcache restore (e.g. Back from a PDP) fires popstate with the
    // href unchanged from what's already rendered — refetching here would
    // replace the fully-hydrated grid with Shopify's plain fallback markup,
    // which is missing the swatch image data. Only refresh when the href
    // actually differs (genuine filter/sort back-forward navigation).
    if (window.location.href === lastRenderedHref) return;
    if (byId("plpRoot")) refreshResults(window.location.href, { pushState: false });
  });

  // Clears the back-button fade on both a fresh load and a bfcache
  // restore, so a page that faded out right before navigating away never
  // comes back (via the browser's forward button) stuck invisible.
  window.addEventListener("pageshow", function () {
    document.body.classList.remove("plp-leaving");
  });

  // Registered BEFORE the first initAll() call below, not after it. That call
  // runs synchronously during script evaluation, so anything it throws used to
  // propagate straight out of this IIFE and abandon every statement after it —
  // this listener and window.BSListing included. The page was then left with
  // no observers, no re-entry point and no way to recover: USF's own raw
  // `background-color: 00DL-CAMEOBEIGE` swatches stayed on screen (and Quick
  // View / wishlist stayed dead) until a refresh happened to win the race.
  // That is the "fine on the first load, broken after four-to-seven
  // refreshes" report.
  document.addEventListener("shopify:section:load", initAll);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    try {
      initAll();
    } catch (err) {
      if (window.console && console.error) console.error("PLP boot failed:", err);
    }
  }

  // External hook for markup injected outside listing.js's own boot/AJAX
  // cycle — assets/product.js fetches Liquid-rendered .plp-card markup
  // for the PDP's "You may also like" grid and appends it to #plpRoot
  // itself, so it needs the same idempotent enhancers refreshResults()/
  // loadNextPage() run on their own injected cards.
  window.BSListing = {
    enhanceCards: function (scope) {
      stripBrandPrefixes(scope);
      tagQuickaddState(scope);
      layoutCardInfo(scope);
      renderSwatchThumbnails(scope);
      markSwatchAvailability(scope);
      hydrateWishlist();
    }
  };
})();
